import React from 'react'
import { IBookPage } from './index'

const chapter01: IBookPage = {
  header: 'header_d1.jpg',
  title: 'Глава 1. Не лучший день в жизни Габриэля Евгеньевича',
  prevLink: 'prolog',
  nextLink: 'chapter02',
  content: <>
    <h2>Университет. Бровь</h2>
    <img src="/images/01_brov.jpg" style={{ float: 'left', margin: '0 10px 10px 0' }} alt='' />
    <p>Если бы кто-нибудь решился взвесить происходящее на неких абстрактных вселенских весах, вышло бы, что Бровь всё-таки питала к Ройшу достаточно тёплые чувства, иначе стала бы она во всё это ввязываться. За окном светило солнышко, падали листики, благодать и суббота, а она торчала в четырёх стенах. Кафешки. Звучит не очень трагично, но можно было потратить этот день на что-нибудь более весёлое — хотя бы вот в Хащину съездить, давно обещала Галку проведать.</p>
      <p>— Убила бы к лешему!</p>
      <p>— Кого?</p>
      <p>— Кого-кого, Ройша, чтоб он провалился, сломал себе что-нибудь и провалился ещё поглубже!</p>
      <p>Абстрактные вселенские весы покачнулись.</p>
      <p>Младший служащий Ивин («Александр, очень приятно» — и поцеловать руку, беее), имеющий двенадцатый уровень доступа к информации и не имеющий прямого отношения к более значимым государственным структурам (точно-точно, честно-честно), живо ухмыльнулся:</p>
      <p>— Провалился и сломал… пальцы?</p>
      <p>— Причём все двадцать, и последовательно, а не параллельно, —&nbsp;Бровь обдумала вопрос решительного плевка на пол и выступила против подобного курса действий. — Пусть отныне складывает их в шкатулочку, а не как обычно. Беее.</p>
      <p>— Это будет слишком ощутимая потеря для человечества! В его обычном шалаше из пальцев могла бы комфортно расположиться пихтская лошадь, — хмыкнул Александр. — А то и две.</p>
      <p>Александр любил поминать пихтов, их карликовых лошадей и весёленькие нравы —&nbsp;к месту и не к месту. Расистские шуточки про малые народы Всероссийского Соседства — это, конечно, прекрасно, но почему именно пихты? В чём радость над ними шутить? Они сами над кем хочешь пошутят.</p>
      <p>То ли дело могучие тавры, или там отделившиеся кассахи со своим плато, или кто ещё есть.</p>
      <p>Ничего Александр не понимает ни в правильном расистском юморе, ни в ройшевских пальцах.</p>
      <p>— Черви. Трупные черви. Сил моих больше нет созерцать это загробное шевеление конечностей. Ты бы знал, как он копошится, когда намеревается куда-нибудь изойти из квартиры! Каждый карман, каждую бумажку, каждую пуговицу, и портфель обязательно полностью перебрать, и газовую колонку проверить, и, конечно, я должна стоять в плаще, потеть и терпеливо ждать, потому что в одиночку мне, конечно, нельзя доверить даже такое ответственное дело, как поездку до Университета.</p>
      <p>— А он-то, небось, думает, что так о тебе заботится.</p>
      <p>И он правда так заботится.</p>
      <p>Александр — придурок блондинистый.</p>
      <p>Бровь, конечно, соврала бы, если бы сказала, что темп жизнедеятельности Ройша её никогда не раздражал (то есть правда, зачем каждый день проверять боковой карман портфеля, если он там ничего не носит?), но это ведь мелочи.</p>
      <p>— Говорю же —&nbsp;невыносимо! И ладно бы просто медленный был. Меня Галка, подруга одна отрядская, аж с июля в гости зовёт, в Хащину. Я только на прошлых выходных собралась. И что ты думаешь? «Сиди дома, пиши курсовую работу»! Алё, сентябрь на дворе, какой курсовик? — Бровь попыталась выразить бездну своего негодования рукой, но вышло бледно. — На днях вон будет десятилетний юбилей Первого Большого Переворота, торжество, отрядские дети рядами, из дальних концов страны люди съедутся. Полторы недели всего осталось, за полторы недели я точно ничего не допишу. И что, на юбилей тоже нет? А если мне к государственному духу приобщиться хочется? У меня, между прочим, есть вполне живой, здоровый и молодой папа —&nbsp;ему и то виднее, где мне сидеть, а где не сидеть, —&nbsp;слегка задохнувшись от накала страстей, Бровь сделала медитативную паузу. — Ну ладно юбилей Первого Большого, ладно Хащина — далеко, страшно, дикие земли, полтора часа на электричке, но сегодня же вообще до маразма дошло. Собираюсь, чтобы сюда поехать —&nbsp;в кафешке с приятелем посидеть. С тобой, в смысле. Уже обулась, снимаю ключи — и снова-здорово: сиди дома и далее по списку. Совсем рехнулся.</p>
      <p>Александр покачал головой с сокрушённым самодовольством (как одно вообще может сочетаться с другим?):</p>
      <p>— Ревнует?</p>
      <p>Вроде блондинистый, а корни у волос тёмные. Если бы не это, был бы, в общем-то, довольно красивым типом.</p>
      <p>Что не повод лезть целовать руки, тем более каждый раз.</p>
      <p>— Куда там, Ройш не опускается до низменных человеческих чувств, —&nbsp;Бровь вздохнула, — а ведь я даже не могла ему сказать, куда и зачем на самом деле еду. Если бы он хоть на секунду заподозрил, что я пытаюсь ему помочь, водил бы меня с пар и на пары под конвоем. Ну да, я у него не только курсовик пишу, я у него практически живу, и сперва было даже приятно, что ему это так важно. Но может же у меня хоть какая-то личная свобода быть, хотя бы в черте Бедрограда? — И испустила ещё один вздох весом в пару килограммов. — Как будто я многого прошу.</p>
      <p>Александр почти посерьёзнел, но тут же исправился, налив ещё коньяку.</p>
      <p>— Тебе, кстати, всё ещё интересно, как у него что? В свете последних событий.</p>
      <p>Должно ли ей быть интересно?</p>
      <p>Наверное, нет, но на самом деле — жутко интересно.</p>
      <p>Интересно, что расскажет Александр. В свете последних событий.</p>
      <p>— Ну скажи уж кратенько, зря, что ли, с боем вырывалась.</p>
      <p>— Кратенько так кратенько, — Александр снова улыбнулся, открыто и до неприличия располагающе (то есть, конечно, развязно и самодовольно), — если кратенько, то всё у него в порядке.</p>
      <p>Бровь выпятила челюсть с максимальной суровостью.</p>
      <p>— Какая жалость. А если чуть подлиннее?</p>
      <p>— Если чуть подлиннее, то — смотри: то, что ты мне принесла, — фотоснимок печати и кода с письма <i>оттуда</i>. Ну, с самого верха.</p>
      <p>— Прям самого-самого?</p>
      <p>— Настолько самого, что такую печать не подделывают. От тех, кто повыше и моего начальства, и бедроградского. Им ведь, хоть они и повыше, кто угодно может запрос послать — и они, если полагается по уровню доступа, ответят. Ты у Ройша в портфеле, соответственно, ответ на запрос и накопала. И мне, конечно, не полагается знать, что означает код, но у меня есть знакомые. Мы проверили, какой у Ройша уровень доступа, это по коду понятно. Четырнадцатый. А проблемы в Университете у какого-то полуслужащего — это, значит, девятый. То есть Ройшу — ну и тебе —&nbsp;волноваться нечего, он тут ни при чём, раз у него уровень доступа простой истфаковский. Как у любого рядового преподавателя или студента.</p>
      <p>И всё-таки, всё-таки Александр был довольно красивым типом. Широкое, открытое лицо, широкие, открытые жесты — в общем, не парень, а одна сплошная рубаха (форменная, младшего служащего). Только брови какие-то дурацкие, слишком идеальные, разлетающиеся к вискам эдакими крыльями —&nbsp;выщипанные, что ли?</p>
      <p>И зачем только люди это с собой творят.</p>
      <p>Этими самыми бровями он периодически делал газетно-журнальное движение, от которого благодарная публика должна была, по всей видимости, падать к его ногам. Причём, кажется, непроизвольно делал. Может, у него тик?</p>
      <p>Бровь (Брованна Андроньевна Шухéр, а не выщипанная часть тела некоего младшего служащего) познакомилась с Александром ещё в мае. Вернее, он с ней познакомился. Представился старым знакомым Ройша из Столицы и поделился тревожной вестью: над одним из полуслужащих в Университете вьются мрачные тучи, и вот бы узнать, какой уровень доступа у Ройша, не является ли он полуслужащим и, соответственно, потенциальной жертвой гнева туч.</p>
      <p>Итак, не является. Значит, знакомство с Александром подошло к концу. Только так, как в мае, всё равно уже не будет. В мае всё обстояло чинно, церемонно и убийственно трогательно: зайти к Ройшу пару раз в неделю на чай, поговорить об академическом, о погоде, об академической погоде, послушать радиопостановку —&nbsp;в общем, сплошные старческие забавы, полные непередаваемого очарования.</p>
      <p>А потом Александр с его тучами и боязнью спросить о проблемах или хотя бы уровне доступа у Ройша лично, потому что Ройш не примет помощь, Ройш ни от кого и никогда ничего не примет, Ройш всегда всё знает лучше всех, а потом —</p>
      <p>В общем, так, как в мае, уже не будет.</p>
      <p>Уровень доступа — простой истфаковский.</p>
      <p>Бровь фыркнула.</p>
      <p>— Уровень доступа! У него мозг четырнадцатого уровня доступа, как у любого рядового преподавателя, и ничего, кроме любого рядового преподавателя, в нём нет. Он больше ничем быть не умеет — даже человеком, я уж не говорю о мужчине. Педагогика головного мозга и всё.</p>
      <p>Александр снова налил коньяку и окинул Бровь очень специфическим взглядом. Температура в кафешке бодро скакнула
        вверх. О неприкрытые интенции!</p>
      <p>— Ладно тебе кипятиться, — изрёк он глубоко неискренним тоном и выпил, —&nbsp;всё же, вроде, хорошо было.</p>
      <p>— Хорошо? Уж куда лучше! — Бровь вспомнила о своих трепетных чувствах и хлопнула по столешнице ладонью (да простит её скатерть, павшая жертвой чрезмерного количества коньяка в стопке). — Ты не понимаешь, мне от него некуда деться. Ройш — это не паренёк из дома напротив, он мой преподаватель, мне на этой кафедре ещё почти три года учиться! Курсовик, в конце концов, когда-то и в самом деле написать надо. У Ройша. Он же, разумеется, своё надо мной научное руководство уже во всех бумажках оформил. Не уйти, хлопнув дверью. Говорю же, — одним махом выпила она то, что оставалось в стопке, — только один выход и есть —&nbsp;убить его к свиньям лешим.</p>
      <p>Александр прищурился на Бровь через графинную пробку. Наверное, это символизировало задумчивость.</p>
      <p>Или ещё более неприкрытые интенции.</p>
      <p>— Помиритесь, — буркнул он, — куда денетесь. В первый раз как будто поругались.</p>
      <p>Консультант по отношениям сыскался тут, а.</p>
      <p>— Не помиримся, — буркнула Бровь в ответ, — ругались уже, да, и я всегда уступала. Я же понимаю, что он странноватый человек. Тут надо либо с самого начала смириться, либо вообще не связываться. Но нет, выясняется, что у меня недостаточно смирения. Не на него. Хочу мести, и, желательно, связанной с тяжёлыми травмами.</p>
      <p>— Помню-помню, переломать пальцы.</p>
      <p>Самое время самостоятельно бухнуть коньяку — и побольше.</p>
      <p>— Пальцы! Ну зачем напомнил? Ты же его знаешь, ты их видел — это не человеческие части тела, это древние подземные монстры, на каждом по двенадцать фаланг, все шевелятся, копошатся, перебирают что-то — и он этими руками норовит меня потрогать! Теми же, которыми подписывает прошение об исключении кого-нибудь из Университета только за то, что тот одет не по форме или эссе принёс на день позже! Ты как будто правда не понимаешь: Ройш — зло, и не только для меня &shy;— для всех, его все ненавидят! Я сперва жалела, думала, он только в Университете такой. Думала, он людей боится,
        а на самом деле всё по-другому — но не по-другому! Ничего там, кроме желания
        кому-нибудь подгадить и красивенько оформить это формуляром, нет! — Бровь
        всё-таки изобразила плевок, хоть и воображаемый. — Ненавижу!</p>
      <p>Закурить бы — но курить в печали
        глупо.</p>
      <p>Александр ещё немного посозерцал свою пробку, подкинул её, довольно ловко
        поймал,
        с аккуратным стуком поставил на стол и заговорщически улыбнулся. Выглядело это
        так, как будто с его лица грациозно вспорхнул индюк.</p>
      <p>Когда человек печален и гневен,
        всё ему не то и не так. Даже красивые, хоть и какие-то неуместные, брови
        младшего служащего Александра.</p>
      <p>— Ты в отряде сортиры взрывала? —
        спросил он решительно.</p>
      <p>Мягко сменил тему беседы.</p>
      <p>— Ничего не знаю, у меня алиби.</p>
      <p>— Везучая, у меня вот в нужный
        момент не оказалось, — и лучезарно улыбнулся. — У нас тут буквально на днях
        смешной вызов был. Звонят, говорят: в одиннадцатом отряде экологическая
        катастрофа, приезжайте, разберитесь. Приехали, разбираемся. Всё чисто и
        благородно, только в туалете по колено. В общем, выяснилось, что дети то ли
        сами изобрели, то ли у кого-то похитили — взрывчатку не взрывчатку, а такие…
        сортирные дрожжи. Находка для отрядского терроризма, безопасно и неотвратимо.
        Кидаешь в унитаз — никаких последствий, а потом кто-нибудь смывает,&nbsp;и
        унитаз выворачивает наизнанку. Всё, что было в недрах, прёт наружу. Изо всех
        сил прёт. Плюс идеальное алиби, между забросом и эффектом ведь может пройти
        сколько угодно времени. В общем, — Александр распахнул замшевую куртку, которой
        даже в помещении стыдливо прикрывал форменный наплечник (интересно, ему не
        натирает?), и продемонстрировал внутренний карман, — я, памятуя о печальном
        детском опыте, один образец экспроприировал. На государственные нужды. Не
        удержался. Вот уже который день хожу и выбираю жертву.</p>
      <p>Бровь несколько секунд тупо
        смотрела на обёрнутую салфеткой пробирку, а потом захихикала, не веря внезапной
        удаче.</p>
      <p>— Это предложение?</p>
      <p>— Как честный человек,
        предупреждаю: ты окажешься у меня в вечном рабстве. Где ещё я такой артефакт
        нарою? Хотя не могу не признать, что наши с тобой интересы в этом вопросе
        совпадают: Константин Константьевич — достойная жертва. Плюс, согласись,
        кровавая месть —&nbsp;это скучно и старо. Будущее за сортирной.</p>
      <p>Хихиканье решительно отказывалось
        прекращаться.</p>
      <p>— После пары-тройки десятков
        часов общения с сантехниками Ройш сам же меня выгонит. И от научного
        руководства откажется. Только это, — Бровь справилась-таки с бушующей
        диафрагмой и призадумалась, — важно, чтобы он понял, что это от меня и что это
        страшная месть, а не стихийное бедствие неизвестного происхождения. Записку,
        что ли, оставить. «Спасибо за всё и приятного купания. Обед для сантехников на
        плите».</p>
      <p>— Слишком прямо, — решительно
        воспротивился Александр, —&nbsp;заподозрит ещё сантехнику в чём-нибудь
        нехорошем, а месть должна застигнуть его врасплох. Надо намёками, намёками.</p>
      <p>— «За то, что Вы со мной сделали,
        Вам причитается именно это и никак не меньше», — гордо задекламировала Бровь.
        Александр расхохотался.</p>
      <p>Потрясающий цинизм!</p>
      <p>— Вот-вот, больше патетики и драматизма!
        Может, контрастный сортирный душ его даже чему-нибудь научит. Ты пойми меня
        правильно — я отношусь к Ройшу с огромным уважением. Если бы он оказался-таки
        полуслужащим и существовала бы вероятность того, что у него проблемы, я бы
        первый помчался ко всем знакомым и незнакомым, чтобы ему помочь. Но это не
        повод так гнусно себя вести — особенно по отношению к такой красивой девушке.
        Патологическую серьёзность надо лечить принудительной сортирной терапией. Авось
        осознает — и, может, всё ещё хорошо сложится, —&nbsp;Александр извлёк пробирку
        из кармана и протянул Брови. Она трепетно приняла дар и немедленно отковыряла
        угол салфетки.</p>
      <p>Мутноватая белёсая жидкость,
        ничего подозрительного.</p>
      <p>Никто никогда и не подумал бы, на
        какие великие деяния оная жидкость способна.</p>
      <p>— Ага, «хорошо сложится». Сомневаюсь.
        Я теперь во всём, кроме сортиров, сомневаюсь и ничему, кроме сортирных дрожжей,
        не верю, —&nbsp;Бровь помахала пробиркой, — да ещё и попала к тебе в вечное
        рабство.</p>
      <p>Александр, крайне пристально и не
        без ностальгии созерцавший бесценный дар, перекочевавший из его кармана в
        большой мир, оторвал взгляд и снова заулыбался.</p>
      <p>И снова разлил коньяк. По
        чуть-чуть.</p>
      <p>— За отрядский терроризм, —
        синхронно приподнял стопку и бровь, — а что касается рабства — будем считать,
        что ты расплатишься со мной, когда расскажешь, как всё прошло. Мне же тоже
        интересно. Только не затягивай с этим делом слишком сильно, меня в любой момент
        могут обратно в Столицу перевести.</p>
      <p>— Чего затягивать, прямо сейчас
        поеду и всё сделаю. Он как раз, — Бровь отыскала на стене часы и изучила данные,
        —&nbsp;минут через двадцать в Университет уходит. У него, разумеется, и в
        субботу там дела найдутся. И да, по его изначальному плану я должна была сидеть
        дома и писать курсовик, пока он в своё удовольствие возится на кафедре с
        бумажками. Это, согласись, просто-таки низко. Но мне сейчас на руку: будет
        время и записку написать, и вещи свои собрать.</p>
      <p>— И плюнуть ему на порог,
        —&nbsp;Александр пощёлкал пальцами в направлении официанта. — Поезжай тогда, я
        расплачусь. И помни: ты делаешь доброе, воспитательное дело.</p>
      <p>— Что может быть добрее и воспитательнее недр сортира, — хмыкнула Бровь, сунула
        пробирку в карман сумки и встала.</p>
      <p>&nbsp;</p>
      <p>Будучи в основном честным
        человеком, Бровь и правда действовала по плану. Честность Брови была столь
        глубока и обширна, что она даже призналась себе в одной простой истине: это всё
        нужно ей исключительно для того, чтобы почувствовать себя героиней шпионского
        романа. В том, чтобы через полгорода везти «безопасное и неотвратимое» вот
        просто так, автопоездом, в кармане сумки, было нечто категорически захватывающее.
        Ну да, почти час дня, автопоезд полупустой, но так ведь интересно, что было бы,
        если бы, скажем, пробирка ну совершенно случайно разбилась. А что было бы при
        прямом контакте с кожей? А если через одежду? А понюхать можно?</p>
      <p>Не проверять, не проверять, Бровь
        не хочет видеть неотвратимых результатов прямо здесь. Она ведь толком не знает,
        насколько белёсая жидкость <i>на самом деле</i> опасна.</p>
      <p>Когда Бровь доехала до дома
        Ройша, тот уже ушёл. Дальше дело оставалось за малым: коридор, сортир, записка,
        покидать в сумку вещи, и будь что будет.</p>
      <p>&nbsp;</p>
      <p>С некоторых пор в жизни Брови
        возникли проблемы с номинацией. Понаслушавшись
        всяких, она невольно стала в мыслях называть преподавателей неподобающим
        образом, и если к Ройшу ей вроде как дозволялось обращаться панибратски, то
        Максим Аркадьевич, например, явно не одобрял наименование себя без отчества.
        Оно и понятно — замзавкаф всё-таки. Серьёзный
        человек. Строгий. Но Бровь же не виновата в том, что у неё в последнее время
        сложились такие тесные отношения с преподавательским составом, и что она волею
        случая узнала, кто входит в Университетскую гэбню (а также что оная
        существует), и что некоторые личности называют Максима Аркадьевича просто
        Максимом, и что это так забавно, что она стала запинаться перед отчеством.</p>
      <p>В конце концов, Максиму
        (Аркадьевичу) всего тридцать два. Всем головам Университетской гэбни по
        тридцать два. Они вместе учились, вместе писали дипломы, вместе надирались
        после защиты, а теперь вместе являются одним из высших органов власти в
        Бедрограде.</p>
      <p>Ей бы так.</p>
      <p>Что там было про вечное рабство?
        Только избранным доступно понимание того, как сложно не трепать на каждом углу
        о существовании Университетской гэбни — тем более что формально это вроде как
        не тайна.</p>
      <p>Бедроградскую гэбню,
        существование которой ещё более не тайна, среднестатистический бедроградец
        (папа Брови, например) всё равно в жизни не видел. На вопрос о том, кто
        управляет городом, он выкатил бы на вопрошающего глаза и ответил бы голосом,
        которым говорят с очень глупыми людьми, — городская власть, кто же ещё? Курсе
        на первом Бровь читала к зачёту что-то о том, что власть, мол, должна быть
        непубличной, ей незачем присутствовать в дискурсе обычных граждан (даже словом
        «гэбня»), бла-бла, нет кухонной политике, да
        производительности труда — но это было на первом курсе и в теории.</p>
      <p>Короче, существование и даже
        состав страшной и таинственной городской власти — это вроде бы и не тайна, но
        такая нетайна, о которой не полагается особо говорить.</p>
      <p>Бедроградом управляла
        Бедроградская гэбня (кто-то же должен посылать Александров на расследование
        экологических катастроф), Столицей, как ни удивительно, Столичная; но вот что в
        Университете тоже есть свой собственный орган власти — и, кажется, даже с таким
        же высоким уровнем доступа — было неожиданно (не трепать, не трепать на каждом
        углу!).</p>
      <p>Для чего нужна Университетская
        гэбня? Чем она управляет-то? Несложно догадаться, что Университетом, но зачем
        им тогда быть на одном уровне доступа с Бедроградской, и вообще — разве без
        этого нельзя прожить?</p>
      <p>Спросить бы преподавателя с того
        зачёта — только кто это был, Бровь, разумеется, давно забыла за ненадобностью.</p>
      <p>Но прожить, видимо, нельзя.</p>
      <p>По крайней мере, Университетская
        гэбня явно существовала, потому что прямо сейчас она восседала на кафедре
        истории науки и техники и созерцала Бровь.</p>
      <p>— Александр, очень приятно, —
        хором поздоровались Охрович и Краснокаменный, не вставая с дивана схватили её
        за руки (физиология этих двоих явно отличалась от человеческой, потому что
        Бровь очень тщательно проследила за тем, чтобы не стоять в зоне их досягаемости)
        и жеманно расцеловали. Не забывая при этом придерживать пальцы так, чтобы в
        случае попытки вырваться они как минимум вывихнулись.</p>
      <p>— А я по-прежнему Бровь.</p>
      <p>— А он по-прежнему Александр, —
        Охрович неодобрительно скривил губы, — ну просто как в семьдесят пятом.</p>
      <p>— Что удивительно для человека
        его положения, — подхватил Краснокаменный.</p>
      <p>— Стареет.</p>
      <p>— Теряет хватку.</p>
      <p>— Какого он нынче цвета?</p>
      <p>Бровь краем уха слышала, что
        головам гэбни полагается синхронно двигаться, продолжать фразы друг друга и
        вообще быть типа одним целым — вроде как это способ воздействия на посетителя.
        Ну что ж, как минимум половина Университетской гэбни этому завету следовала. Ущерб,
        по крайней мере, Охрович и Краснокаменный наносили значительный.</p>
      <p>— В регионе лица
        —&nbsp;телесного, подробнее не проверяла.</p>
      <p>Эти двое не порицают панибратство
        в свой адрес.</p>
      <p>Если они решат кого-то убить (а
        они решат), то исключительно беспричинно.</p>
      <p>— О бессмысленное дитя! Глаза,
        волосы —&nbsp;вот что нас волнует!</p>
      <p>— Кожа уже не модна в этом
        сезоне.</p>
      <p>— Если только он не расширил свой
        арсенал маскировки.</p>
      <p>— У него есть накладные усы?</p>
      <p>— Мушка на щеке?</p>
      <p>— Пчёлка на заднице?</p>
      <p>— Деревянная нога?</p>
      <p>— Может, он переоделся женщиной?</p>
      <p>— Женщиной-Александром?</p>
      <p>Максим (Аркадьевич) старательно
        испепелил Охровича и Краснокаменного своим претендующим на орлиность
        взором.</p>
      <p>— Мы тоже хотим на свидание с
        Александром, — постановил Краснокаменный. </p>
      <p>—&nbsp;Мы это заслужили.</p>
      <p>Эти два человека, между прочим,
        вели историю Университета.</p>
      <p>У первокурсников.</p>
      <p>Правда, это компенсировалось тем,
        что они же вот уже семь лет заведовали университетским борделем. Собственно,
        они его и открыли.</p>
      <p>Идеологическое решение, ничего
        личного.</p>
      <p>Желающие поспорить могут обсудить
        это с Охровичем и Краснокаменным в частном порядке.</p>
      <p>— Как известно, гэбни могут
        встречаться только четыре на четыре, —&nbsp;изрёк Максим (Аркадьевич).</p>
      <p>Гэбни?</p>
      <p>Но Александр —</p>
      <p>— Всего лишь младший служащий!</p>
      <p>— Двенадцатый уровень доступа!</p>
      <p>— Мы имеем полное право вызвать
        его на ковёр.</p>
      <p>— Дальше ковра юрисдикция
        Университета не распространяется.</p>
      <p>— Если покрыть ковром всю площадь
        Всероссийского Соседства, мы станем непобедимы.</p>
      <p>А самое страшное —&nbsp;прервать
        этот поток было невозможно, особенно с учётом того, что Охрович и
        Краснокаменный продолжали сжимать руки Брови.</p>
      <p>Наверное, примерно так ощущает
        себя человек, который тонет и уже никак не может удержаться на поверхности, и
        вода неотвратимо смыкается над головой, и, когда последняя искра надежды
        начинает тлеть, вдруг выламывает ему пальцы.</p>
      <p>Бровь панически поискала глазами
        спасения.</p>
      <p>— Вашего Александра на самом деле
        зовут Гошкá, —&nbsp;спасательный круг прилетел от Лария Валерьевича,
        секретаря кафедры и четвёртого головы Университетской гэбни.</p>
      <p>Знакомьтесь: Брованна Шухер,
        героиня шпионского романа, где даже есть самые настоящие вымышленные имена.</p>
      <p>— Гошкá? А полное как?</p>
      <p>— Это и есть полное. Обычное
        польское имя, ударение на второй слог. Его прадед переехал сюда из
        Польско-Итальянского Содружества, — Ларий Валерьевич поднялся из-за стола и
        отправился ставить чайник. —&nbsp;Так вот, Гошка Петюньевич — один из голов
        Бедроградской гэбни. Примечателен тем, что, прикидываясь младшим служащим,
        предпочитает сам выполнять работу, которую, по-хорошему, и полагалось бы
        выполнять младшему служащему. Вот, например, с вами пообщался.</p>
      <p>Ах ты ж надо же ж!</p>
      <p>Мало того, что Бровь якшается с
        Университетской гэбней, она теперь ещё и коньяк распивает с Бедроградской!</p>
      <p>А эти крепче чая никогда ничего
        не предложат, хотя, известное дело, хранится на кафедре достаточное количество
        разнообразных жидкостей. Об этом, в принципе, знали все студенты, которым
        доводилось заглядывать дальше кафедрального конференц-зала, то есть учебной
        аудитории, то есть последнего приличного помещения. Дальше — там, где сейчас
        пребывала Бровь и прочие —&nbsp;начиналась преподавательская вотчина с уютными
        деревянными стенами, хранящими следы былых сражений. Например, там вверх ногами
        висела карта Афстралии, отмеченная жирным «нам сюда». Рядом с ней под потолком распластался
        манекен среднестатистического представителя Революционного Комитета, выполненный
        по всем канонам художественной условности (то есть опознаваемый в основном по
        меняющейся время от времени подписи и элементам костюма). Нынче он был Веней,
        за что получил симпатичный парик, ошейник, мундштук и лишился рубашки.</p>
      <p>Самый что ни на есть канонический
        Веня, гордый работник оскопистского салона.</p>
      <p>То есть борделя.</p>
      <p>Напитки-крепче-чая не очень
        скрытно хранились на столе секретаря, который (стол, не секретарь, хотя
        секретарь почти всегда прилагался), между прочим, был первым, на что натыкался
        взгляд при входе в помещение.</p>
      <p>Впрочем, студенты не очень часто
        бывали в преподавательской вотчине, поскольку у любого посетителя имелся неиллюзорный шанс получить ведро воды на голову.</p>
      <p>Передовая кафедра одного из крупнейших университетов мира.</p>
      <p>Бровь представила себе распитие
        алкогольных напитков сперва с Максимом (Аркадьевичем), потом с Охровичем и
        Краснокаменным и решила, что вот и хорошо, вот и пусть не предлагают.</p>
      <p>— Значит, всё-таки пообщались?
        Успешно? — подал голос Максим (Аркадьевич). Оный голос звучал как-то со
        стороны, и среди его обертонов слышались не то фанфары, не то траурный марш.</p>
      <p>Ввиду чего Бровь извлекла
        пробирку из сумки с несколько непристойной торжественностью. О да, она
        заслужила этот момент триумфа.</p>
      <p>Охрович и Краснокаменный с
        грохотом пали ей в ноги. А поскольку размера они были немалого, этажом ниже наверняка
        обрушилась штукатурка.</p>
      <p>— Сортирные дрожжи, — дикторским
        тоном проговорила Бровь в повисшей тишине. Свитера Охровича и Краснокаменного
        служили ей вполне пристойными софитами — по крайней мере, смотреть на них без
        рези в глазах было невозможно.</p>
      <p>Это они сегодня ещё скромно оделись.</p>
      <p>Максим (Аркадьевич) бурил
        пробирку глазами с такой тревогой, что Бровь сдалась и решила не додерживать
        паузу.</p>
      <p>— Это Александр — то есть Гошка
        —&nbsp;мне сие так представил. Кажется, всё прошло успешно: я рассказала, как
        меня утомил Константин Константьевич, убила бы, он меня послушал, подумал и в
        ответ рассказал историю о том, что отрядские дети вот это, — удержаться и не
        помахать пробиркой было невозможно, — кидают в унитазы, чтобы оттуда лезло
        содержимое. Предложил осчастливить Константина Константьевича в порядке
        страшной мести. Ну и вот. Оно.</p>
      <p>Ларий Валерьевич аккуратно забрал
        у Брови пробирку, несколько секунд подержал её в руках, помялся и с растерянным
        видом поместил ёмкость в стакан для карандашей. Максим (Аркадьевич) медленно
        выдохнул и закрыл глаза. Охрович и Краснокаменный, подскочив, страстно
        поцеловали Бровь в брови, попутно чуть не выбив ей глаза подбородками.</p>
      <p>— Значит, началось, — Максим
        (Аркадьевич) неожиданно улыбнулся в пространство и повторил, —&nbsp;началось.</p>
      <p>Бровь почувствовала, как у неё на
        шее забился пульс.</p>
      <p>Потом она обнаружила, что эффекта
        прилива адреналина можно достичь, ритмично нажимая человеку на сонную артерию.</p>

      <p>Наверное, это всё-таки проявление
        дружелюбия со стороны Охровича и Краснокаменного. По крайней мере, очень
        хотелось в это верить.</p>

      <p>— Вы молодец, —&nbsp;Ларий
        Валерьевич что только не пожал ей руку (и чего все так одержимы её верхними
        конечностями? Есть же столько других прекрасных частей тела!). — Мы все
        переживали. И простите, что сразу не сказали вам, с кем именно вы имеете дело.
        План и так был сомнительный, если бы вы разволновались от близости головы
        Бедроградской гэбни и переиграли, мы бы в лучшем случае ничего не получили.</p>

      <p>А в худшем оный (или оная? Как
        вообще правильно?) голова перегрыз бы ей горло?</p>

      <p>Только непосредственная близость
        Охровича и Краснокаменного и их крайне боевой настрой не позволили Брови
        спросить это вслух. Ещё воспримут как руководство к действию.</p>

      <p>Все немного помолчали.</p>

      <p>Как глупо!</p>

      <p>— И что теперь? —&nbsp;вопросила
        Бровь, ибо должен же был кто-то что-то сказать. И кто, как не она, глупая
        третьекурсница, которая попала во всю эту историю совершенно случайно.</p>

      <p>Понравилась Ройшу.</p>

      <p>Ройшу, который сейчас невозмутимо
        читал пары, и посмотрела бы Бровь на того, кто сумел бы по нему догадаться, что
        творится в его доме, на кафедре и во всём Бедрограде.</p>

      <p>— Мы поехали к зданию
        Бедроградской гэбни, — заявил Охрович.</p>

      <p>— Внутрь нас не пустят, но можно
        же снаружи посмотреть, будет ли там масштабное шевеление, — подхватил
        Краснокаменный.</p>

      <p>— Если нам не дают быть с Александром,
        мы можем сами побыть Александром.</p>

      <p>— Прикинемся младшим служащим,
        никто не догадается.</p>

      <p>— Гражданская бдительность —
        залог спокойствия Бедрограда!</p>

      <p>— Прекратите балаган, — громыхнул
        Максим (Аркадьевич), восставая с дивана. — Мы ещё не со всем разобрались.
        Бровь, диктофон?</p>

      <p>Очень непросто быть героиней
        шпионского романа, когда чувствуешь себя первокурсницей, сдающей экзамен.
        Максим (Аркадьевич) в своём привычном и повседневном тёмно-коричневом пиджаке —
        спасибо хоть без галстука сегодня — плохо вписывался в антураж захватывающих
        поворотов событий.</p>

      <p>Что, с другой стороны, щекотало
        нервы, напоминая о реальности происходящего.</p>

      <p>Бровь гордо извлекла диктофон из
        кармана брюк, почти даже не запутавшись в проводе, ведущем к микрофону (когда
        Охрович и Краснокаменный закрепляли его в украшающем свитер Брови цветке, они в
        самом прямом смысле поразили её в самое сердце — острыми предметами, несколько
        раз). Диктофон, в отличие от пиджака Максима (Аркадьевича), был вполне достоин
        шпионского романа: плоский, почти невесомый — мог бы незаметно поместиться в
        кулаке, если бы у неё был кулак, как у всё того же Максима (Аркадьевича).
        Работающий совершенно бесшумно и украшенный крупными рельефными кнопками, по
        которым даже на ощупь не промахнёшься. Кому попало такие не выдают, только
        младшим служащим.</p>

      <p>А поскольку Бровь младшим
        служащим уже шесть часов как была — и, в отличие от Гошки-Александра, по-настоящему,
        — ей его выдали.</p>

      <p>Всё те же шесть часов назад,
        сопроводив инструкцией «думаем, твой тонкий ум подскажет тебе, куда жать».</p>

      <p>Задумавшись о прелестях своего нового
        уровня доступа, Бровь не сразу заметила, что все снова молчат и как-то нехорошо
        смотрят в её сторону.</p>

      <p>Ларий Валерьевич безмолвно налил
        в стакан чего-то крепче чая, выпил половину и протянул Максиму (Аркадьевичу) остатки.
        Которые тот не менее безмолвно опрокинул в себя.</p>

      <p>Что-то не так?</p>

      <p>— Эта кнопка, о дочь доктора
        наук, называется «перемотка вперёд», — проинформировал Краснокаменный.</p>

      <p>— Не «запись», — пояснил Охрович.</p>

      <p>— При нажатии на неё не
        происходит записи человеческой речи.</p>

      <p>— И прочих звуков, акустические
        колебания которых достигают микрофона.</p>

      <p>— Чему вас, младших служащих,
        только учат!</p>

      <p>— Вот Александр не путает кнопки
        на диктофоне.</p>

      <p>— Александр — приличный человек,
        он закончил юрфак.</p>

      <p>— Закончил недавно, а уже аж младший
        служащий.</p>

      <p>— Он уже пятнадцать лет как
        недавно закончил юрфак. И до сих пор не путает кнопки.</p>

      <p>Бровь бы тоже была хорошим
        Александром и не путала кнопки, если бы, может быть, Охрович и Краснокаменный
        чуть более внятно объяснили ей, как этой машинкой пользоваться? Ну так, в
        порядке безумного предположения, что это может помочь?</p>

      <p>Максим (Аркадьевич) смотрел на
        происходящее со скорбью в очах, и Ларий Валерьевич поддерживал его. На фоне
        багровых кафедральных занавесей (настоящий бархат, и хотите ли вы знать, как и
        зачем) они выглядели посланниками смерти.</p>

      <p>— Извините, —&nbsp;выдавила
        Бровь. Сейчас ей, по-хорошему, должны сказать, что она не виновата и что «что с
        неё взять», но как-то и правда нехорошо получилось. Если свидетельства её
        общения с Гошкой-Александром так важны, наверное, стоило предварительно
        потренироваться обращению с диктофоном, а не только ронять слюни на его лёгкий
        металлический корпус.</p>

      <p>Что Бровь не виновата, между
        прочим, так никто и не сказал. И история никогда не узнает, собирался ли,
        потому что в этот момент в преподавательскую вотчину вошёл Габриэль Евгеньевич.</p>

      <p>Каждый раз, когда Габриэль
        Евгеньевич входил в помещение, там повисала тишина (наверное, быть Габриэлем
        Евгеньевичем довольно скучно). И хоть в данном случае он израсходовал свою
        магическую способность впустую, внимание всё равно переключилось в нужную сторону
        — то есть подальше от Брови.</p>

      <p>Бровь всерьёз подозревала, что
        Габриэль Евгеньевич —&nbsp;не человек, а кафедральный дух. Возможно, идеальная
        компонента манекена среднестатистического члена Революционного Комитета. Это,
        по крайней мере, объясняло бы полное отсутствие у него цвета кожи, хоть
        каких-то признаков возраста и — честное слово — запаха.</p>

      <p>Экспертизы Бровь не проводила, но
        была весьма и весьма уверена.</p>

      <p>Соответственно, явление Габриэля
        Евгеньевича в преподавательскую вотчину следовало расценивать как погодное.
        Заведующий кафедрой истории науки и техники оказался обыкновенным чёрно-голубым
        облаком с изящной проседью. Уведомите газеты.</p>

      <p>Облако тихо склонило голову,
        откидывая чёрную чёлку (с той самой изящной проседью), и обвело присутствующих
        ярко-голубыми глазами, полными безграничной и смиренной печали.</p>

      <p>Присутствующие смутились.</p>

      <p>— У тебя же сейчас совещание, —
        Максим (Аркадьевич) сделал быстрый шаг к вошедшему, словно пытаясь загородить всю
        преподавательскую вотчину своей широкой спиной. Бровь смутилась ещё раз. Никто
        и никогда особо не скрывал, что заместитель заведующего кафедрой живёт у
        заведующего кафедрой дома и имеет с ним весьма порочную связь, но в присутствии
        студентов они всегда держались строго официально. Это раз. Два — а почему,
        собственно, явление Габриэля Евгеньевича вызвало такой испуг?</p>

      <p>Происходящее от него скрывают?</p>

      <p>— Там решительно нечего делать, —
        печально поведал Габриэль Евгеньевич, опуская взгляд.</p>

      <p>Воплощение печали на этой грешной
        земле.</p>

      <p>Охрович и Краснокаменный сделали
        громкие жевательные движения, символизирующие поглощение мелких закусок при
        прослушивании увлекательной радиопостановки.</p>

      <p>— Габриэль Евгеньевич, — воззвал
        к бюрократическому разуму Ларий Валерьевич, — мы все понимаем, что это
        совещание — скорее формальная процедура, но вы должны там присутствовать.
        Лингвистический факультет послал на нашу кафедру отдельный запрос, их новому
        проекту требуется не только поддержка всего исторического факультета, но и наше
        частное мнение. Они отдельно попросили вашего участия и подписи — это ведь не
        так сложно, в конце концов, они тоже…</p>

      <p>На этом тирада Лария Валерьевича
        оборвалась, потому что случилось нечто категорически неожиданное.</p>

      <p>Максим (Аркадьевич) издал
        странный звук, сделал ещё один широкий шаг вперёд и обрушил свой кулак (тот
        самый, где уютно уместился бы диктофон, а если подумать, то и два) прямо в лицо
        Габриэлю Евгеньевичу.</p>

      <p>Оййй.</p>

      <p>По результатам этого действия
        заведующий кафедрой истории науки и техники живописно (и на удивление
        беззвучно) разметался по полу, его тонкие очки (на удивление не разбившись)
        звякнули о ножку книжного шкафа, а лёгкий серебристый плащ распахнулся,
        демонстрируя шёлковую кружевную рубашку стоимостью в годовую стипендию Брови.</p>

      <p>Охрович и Краснокаменный
        разразились раундом бурных аплодисментов.</p>

      <p>Максим (Аркадьевич) смотрел на
        деяние кулака своего с плохо скрываемой растерянностью. Судя по недвижно
        запрокинутому подбородку, приходить в себя съехавший на пол Габриэль Евгеньевич
        не намеревался. Оно и понятно: по убийственной силе кулак Максима (Аркадьевича)
        явно находился в одной весовой категории с автопоездом.</p>

      <p>Максим (Аркадьевич) прочистил
        горло, подобрал отлетевшие очки и вернул их на переносицу владельца. Стало ещё
        живописнее. Что делать дальше, Максим (Аркадьевич) явно не представлял.</p>

      <p>Кажется, так далеко его план не
        заходил.</p>

      <p>Бровь слишком хорошо знала
        драматизм подобных ситуаций, но не слишком хорошо понимала, зачем избиение
        погодных явлений потребовалось в принципе. Она почти успела спросить об этом вслух,
        но тишину прервал Ларий Валерьевич, уже успевший набрать некий номер:</p>

      <p>— Служебное такси, —&nbsp;вежливо
        попросил он. — До Порта. С провожатым шестидесятикилограммовой грузоподъёмности,
        —&nbsp;и как ни в чём не бывало повесил трубку.</p>

      <p>Чего?</p>

      <p>Порт?</p>

      <p>При чём здесь Порт?</p>

      <p>Или всё происходящее — это тонкий
        план по убийству Габриэля Евгеньевича?</p>

      <p>— Да, Порт, — Максим (Аркадьевич)
        обернулся и предпринял попытку улыбки, — наверное. Видите ли, Бровь,
        предполагалось, что Габриэль Евгеньевич пробудет на совещании весь день. То,
        что сейчас происходит в Университете, — события политические, и он не имеет к
        ним прямого отношения. Да и косвенного хотелось избежать.</p>

      <p>— Я понимаю, — предельно
        дружелюбно ответила Бровь, делая незаметный шажок в сторону безопасности
        —&nbsp;то есть от Максима (Аркадьевича) подальше. Охрович и Краснокаменный ненавязчиво
        сомкнулись за её спиной.</p>

      <p>Вся преподавательская вотчина —
        одна большая ловушка, и горе тому, кто в неё попал.</p>

      <p>— Сумеете сопроводить Габриэля
        Евгеньевича? — невозмутимо спросил Ларий Валерьевич.</p>

      <p>— Если впадёт в буйство, можешь
        тоже дать ему по лицу, —&nbsp;встрял Охрович.</p>

      <p>— Надо попытаться сделать это
        доброй кафедральной традицией, — согласился Краснокаменный.</p>

      <p>— Возможно, даже элементом
        вступительных экзаменов.</p>

      <p>— Хотя и повысится процент
        самоубийств среди непоступивших.</p>

      <p>Ларий Валерьевич, надо заметить,
        не сбился и продолжил свою речь, как только у Охровича и Краснокаменного
        закончилось дыхание:</p>

      <p>— Там для него сейчас самое
        безопасное и надёжное место. А с учётом того, что запись вашего общения с
        головой Бедроградской гэбни отсутствует, лучшее, что мы можем сделать,
        —&nbsp;это зафиксировать и заверить ваши показания. Университетская гэбня
        обладает таким правом, но, согласитесь, если ваши показания будут зафиксированы
        нами, это может выглядеть… предвзято. Лучше подыскать наиболее нейтральную
        инстанцию.</p>

      <p>Ага. В Порту.</p>

      <p>Пусть Бровь выслушает капитан
        дальнего плаванья, старый суровый моряк с трубкой — или нет, лучше махоркой — и
        деревянной ногой. Это будет выглядеть <i>действительно</i> непредвзято!</p>

      <p>А папа потом сможет навещать её в
        дурдоме.</p>

      <p>Максим (Аркадьевич) снова
        нахмурился, и в преподавательской вотчине разом потемнело.</p>

      <p>— Не хотелось снова тревожить
        Портовую гэбню по подобным вопросам, — мрачно изрёк он, взял со стола диктофон,
        взвесил его в руке (плохое орудие для убийства) и вздохнул, —&nbsp;хотя,
        кажется, других вариантов нет.</p>

      <p>Портовую гэбню?</p>

      <p>Снова тревожить?</p>

      <p>Что?</p>

      <p>Порт — это формально всего лишь
        район Бедрограда (где располагается, не поверите, порт), но, говорят, на самом
        деле та�� расположился целый самостоятельный город. Отдельная хаотическая
        махина, полная старых суровых моряков с трубками и махоркой, которым не писаны
        законы и которые могут прирезать за углом просто так — потому что им не писаны
        законы. Говорят. Говорят, там живут контрабандисты, беглые заключённые, нелегальные
        иностранцы и просто все те, кого тянет выписаться из закона или порезать за
        углами.</p>

      <p>А теперь вот ещё говорят, что там
        сидит своя собственная гэбня и что Брови следует туда поехать с бездыханным
        Габриэлем Евгеньевичем наперевес. Видимо, в качестве приманки.
        Девятнадцатилетняя девушка и тело в кружевной рубашке.</p>

      <p>Они издеваются?</p>

      <p>— Есть ли у тебя последнее
        желание? — участливо вопросил Краснокаменный.</p>

      <p>— Скажи нам, мы поклянёмся его
        исполнить, — заверил Охрович.</p>

      <p>— Может быть, ты хочешь
        попрощаться с Ройшем?</p>

      <p>— Он сейчас на лекции, но,
        конечно, будет рад прервать её ради драматической сцены расставания!</p>

      <p>На самом деле сейчас больше любых
        сцен с Ройшем Бровь хотела бы, чтобы папа <i>никогда</i> не узнал, что она едет в Порт. Он, конечно, ещё не очень старый, совсем даже не
        старый, но это явно лишнее переживание в его жизни — сердце слабое, мало ли
        чего.</p>

      <p>Вот только это совсем не то
        желание, которое стоит излагать Охровичу и Краснокаменному.</p>

      <p>— Заверенные Портовой гэбней
        показания, конечно, не столь однозначны, как аудиозапись, но тоже неплохи, — со
        сдержанным бюрократическим оптимизмом сказал Ларий Валерьевич Максиму (Аркадьевичу).
        — Выглядеть, думаю, будут вполне убедительно.</p>

      <p>— К тому же, если у Брови не было
        диктофона, значит, мы ничего и не подозревали, — кивнул тот. — Может, так оно
        даже лучше. Только надо соответственным образом перекроить наш запрос.
        Займитесь. И отзвонитесь по поводу проверки
        аппаратуры, не хотелось бы ещё одной технической накладки — в подвале у
        Константина Константьевича взять показания не у кого. А вы двое, — обратился он
        к Охровичу и Краснокаменному, — хотите быть Александром — будьте им,
        небесполезно. Я же займусь самой сложной и опасной частью операции: пойду
        читать лекции. И извиняться перед лингвистическим факультетом, — и посмотрел на
        Габриэля Евгеньевича с той самой смиренной печалью.</p>

      <p>Охрович и Краснокаменный
        откозыряли и удалились с назиданием непременно съездить телу Габриэля
        Евгеньевича по лицу, Максим Аркадьевич с Ларием Валерьевичем закопались каждый
        в свои бумажки, так что Бровь некоторое время просто сидела на диване, созерцая
        преподавательскую вотчину и более-менее прилично пристроенное на соседний диван
        тело. Самым общительным в помещении остался манекен среднестатистического члена
        Революционного Комитета, но, поскольку сегодня он был Веней, Брови достался
        только томный и загадочный взор.</p>

      <p>Удивительные дела творились на
        кафедре истории науки и техники.</p>

      <p>И не намеревались заканчиваться:
        по прошествии какого-то там количества времени дверь без стука распахнулась, и
        в преподавательскую вотчину вошло очередное действующее лицо.</p>

      <p>Или даже действующая коса, потому
        что лицо было таврской национальности.</p>

      <p>Видимо, таксист.</p>

      <p>Тавр-таксист.</p>

      <p>В тельняшке под курткой и с не
        шибко прикрытым ножом на бедре. С таврской косой на правом плече и чёрной
        таксистской повязкой на левом. С решимостью на лице.</p>

      <p>И <i>вот это</i> только что прошло по всему факультету.</p>

      <p>Как тавр вообще может быть
        таксистом? Бровь вовсе не страдала ксенофобией, но всё-таки тавры — это малый
        народ с Южной Равнины, они скачут на конях и периодически перерезают
        кому-нибудь глотки, а не сидят за рулём и не транспортируют трепетных завкафов
        в Порт. То есть это, без обид, но разве тавры умеют водить такси?</p>

      <p>Вот будет веселье, если они по
        дороге кого-нибудь собьют.</p>

      <p>Тело, наверное, можно будет
        сбросить в море — главное, не перепутать с Габриэлем Евгеньевичем. Или с самой
        Бровью, а то мало ли. Вдруг в тайных священных текстах ей предначертана гибель
        от руки тавра?</p>

      <p>Тавра-таксиста!</p>

      <p>Хорошо, что пара не успела
        закончиться, потому что спустившаяся к главному входу процессия выглядела
        крайне колоритно. Максим (Аркадьевич) бережно погрузил тело Габриэля
        Евгеньевича на заднее сиденье и подпёр его Бровью, после чего молча пожал руку
        тавру-таксисту. Ларий Валерьевич передал оному конверт со служебной запиской.</p>

      <p>Для доведения картины массового
        безумия до совершенства в такси играла Кармина Бурана. Что Бровь раньше знала о
        вкусах тавров!</p>

      <p>Когда такси тронулось, она
        потратила некоторое время на то, чтобы убедиться, что водитель не убьёт её и не
        съест, после чего предалась созерцанию бодро проезжающих пейзажей. В лучах всё
        ещё утреннего и ну такого сентябрьского солнца Бедроград был жёлтым, как
        наряженный к празднику цыплёнок. Очень квадратный цыплёнок. И очень большой. И
        не цыплячьего цвета, а такого, скорее персикового. Короче, непонятно, при чём
        тут вообще цыплёнок —&nbsp;и, кстати, почему они не поехали прямо в Порт, а
        вывернули из Старого города в новые районы и выписывают петли?</p>

      <p>Скрываются от слежки, наверное.
        Как настоящие шпионы из настоящего романа.</p>

      <p>Либо так, либо тавр-таксист
        всё-таки хочет съесть их с Габриэлем Евгеньевичем.</p>

      <p>Последний продолжал пребывать
        где-то вне своего сознания, уронив голову Брови на плечо (так случайно вышло на
        каком-то повороте, честное слово). Ненормально чёрные волосы слегка (но в
        рамках прекрасного) растрепались и щекотали ей нос —&nbsp;и, между прочим,
        действительно не пахли! Из-под волос поблёскивала оправа очков, дальше
        виднелась линия шеи, широкий воротник, ключицы —&nbsp;ну и так далее.</p>

      <p>Брови вдруг подумалось, что
        никогда не оказывалась с Габриэлем Евгеньевичем один на один в ситуации полной
        безнаказанности.</p>

      <p>Но он же твой завкаф! —
        патетически воскликнула светлая сторона её личности.</p>

      <p>Тёмная непристойно заржала, и
        Бровь была склонна с ней согласиться.</p>

      <p>Нежно приподняв подбородок своего
        завкафа, Бровь изучила его лицо, и в бессознательном состоянии несущее печать
        безбрежной печали. И почему-то не несущее никаких следов кулака Максима
        (Аркадьевича). Ни синяка, ни какой-нибудь хотя бы ссадины для приличия
        —&nbsp;ничего.</p>

      <p>Это было уже слишком и решительно
        требовало следственного эксперимента. В конце концов, нехорошо манкировать
        наставлениями Охровича и Краснокаменного.</p>

      <p>Покосившись на каменную спину
        тавра, Бровь аккуратно выпутала очки Габриэля Евгеньевича из его волос. Кстати,
        его волос она тоже раньше никогда не трогала.</p>

      <p>Бездны мировой фрустрации
        снисходят на всякого, кто трогает волосы Габриэля Евгеньевича.</p>

      <p>Это закон.</p>

      <p>А фрустрацию следует вымещать,
        чтобы не свихнуться, верно? Конечно, верно. А ещё он как-то раз поставил ей
        четвёрку и не объяснил, за что.</p>

      <p>В общем, в свой удар Бровь
        вложила всю накопившуюся боль и обиду.</p>

      <p>Каменная спина тавра не
        шелохнулась.</p>

      <p>Тело Габриэля Евгеньевича
        —&nbsp;тоже.</p>

      <p>Бровь внимательно всмотрелась в
        скулу жертвы. Хотя бы покраснение кожи? Пожалуйста? Он же всё-таки материален,
        иначе зачем шестидесятикилограммовая грузоподъёмность тавра?</p>

      <p>В надежде высмотреть у Габриэля
        Евгеньевича хоть какую-нибудь физиологическую реакцию на произошедшее Бровь
        совершила фатальную ошибку. Она нацепила его очки (ну мало ли поможет).</p>

      <p>Так и выяснилось, что заведующий
        кафедрой истории науки и техники носит очки без диоптрий. От человека,
        предпочитающего рубашки дореволюционного кроя и закрывающую пол-лица стрижку
        под Веню, конечно, можно ожидать всего, но это всё-таки было как-то слишком.</p>

      <p>Очки с простыми стёклами.</p>

      <p>Не бойтесь, Габриэль Евгеньевич,
        ваша тайна умрёт вместе со мной. Главное —&nbsp;чтобы тавр не предал.</p>

      <p>И тавр не предал —&nbsp;по
        крайней мере, пока что. Проехав вдоль бесконечной череды складских стен цвета
        уныния, такси остановилось перед шлагбаумом. Судя по всему, дальше полагалось
        продвигаться пешком.</p>

      <p>Бровь поспешно нацепила очки
        обратно на завкафа.</p>

      <p>Ничего не было!</p>

      <p>Тавр безмолвно распахнул для
        Брови дверь такси, извлёк Габриэля Евгеньевича, с ужасающей профессиональностью
        подхватил его на руки, кивнул головой какому-то сомнительному типу в сторожевой
        будке и махнул в предполагаемом направлении движения. Обойдя шлагбаум, который
        и не думал открываться, тавр с Бровью упёрлись в ещё одну стену складов, раскинувшуюся
        во все стороны серой колбасенью. Потянув ручку на воротах
        ближайшего, тавр не без труда распахнул их и скрылся в проржавевшем полумраке.</p>

      <p>Предполагалось, что Бровь
        последует за ним.</p>

      <p>Пусть эта информация никогда не
        дойдёт до папиного слабого сердца.</p>

      <p>Склад был пустым, промозглым и
        очень длинным, но в конце концов дверь на противоположном конце обнаружилась и
        даже открылась.</p>

      <p>Итак, Бровь попала в Порт.</p>

      <p>Ознаменовалось это тем, что её
        чуть не сбил с ног какой-то замшелый дядька в тельняшке, стремительно ползший
        по стеночке. Под ногами загудело так, как будто там была не твёрдая земля, а
        лист железа, вежливо присыпанный сверху в целях конспирации. Палуба, или скорее
        днище перевёрнутого корабля. Примерно такого, как тот, который возвышался прямо
        перед носом Брови —&nbsp;и, судя по всему, играл роль жилого строения и навеса
        одновременно.</p>

      <p>Всё государство переворачивает
        деревья, а Порт, оказывается, —&nbsp;корабли.</p>

      <p>Наверное, это идеологично.</p>

      <p>В остальном возникало ощущение,
        что Бровь попала на картинку из учебника общей истории Бедрограда. Кривые
        улочки, сделанные из не пойми чего домики, толкотня, настоящие деревянные
        вывески, запах грязи, водорослей и ещё чего-то терпкого —&nbsp;всё это смутно
        напоминало Старый город. Старый город, который старательно поливали помоями на
        протяжении пары-тройки десятков лет. И всё это предположительно ушло в безвозвратное
        прошлое. Шум, толчея; резкие трели корабельных гудков, сливающиеся в один
        ушераздирающий (раздирающий уши, в смысле) звон. И самые настоящие чайки,
        вьющиеся целыми стаями то тут, то там.</p>

      <p>Как так вышло, что всего этого не
        видно и не слышно из города? Ведь нет же ни высоких стен, ни купола, ни ограды
        кроме цепи складов.</p>

      <p>Некто со шрамом через всё лицо и
        острой нехваткой зубов широко улыбнулся Брови и направился себе дальше.</p>

      <p>Наверное, лучше не отставать от
        тавра.</p>

      <p>Шли они минут двадцать
        —&nbsp;снова выписывая какие-то безумные кренделя, проходя через кишащие
        деятельностью склады (совсем не такие, как те, что при входе, а маленькие и
        обросшие лавочками вдоль внешних стен), петляя и сворачивая в незаметные на
        первый взгляд переулки. Особенно удивляло то, что большинство людей, которых
        они встречали по пути, и в самом деле носили тельняшки. Тельняшка была в
        некотором роде символом Порта — не то чтобы запрещённым в основной части
        города, но попросту там ненаходимым. Известно, что
        изначально этот предмет одежды вообще ввели для того, чтобы приличные люди в
        строящемся Петерберге могли опознавать всякую портовую шваль издалека — а
        портовой швали вроде как понравилось, и из клейма тельняшка превратилась в
        эдакий инструмент самоопределения и предмет гордости. И именно поэтому Бровь
        была уверена, что значимость тельняшки для Порта весьма преувеличена — на
        практике ведь всегда выясняется, что у каждого свои предпочтения.</p>

      <p>Ан нет. Портовые люди их
        действительно носили.</p>

      <p>Конечным пунктом путешествия по
        Порту, в ходе которого Бровь увидела всё на свете, кроме самого ожидаемого (то
        есть моря), был самый обычный по местным меркам дом в три этажа — кажется,
        всё-таки кирпичный.</p>

      <p>Какая жалость, что не
        перевёрнутый корабль!</p>

      <p>Судя по потрёпанной вывеске, в
        доме располагалась татуировочная мастерская. Тавр проигнорировал её манящие
        неизвестностью окна, бессовестно быстро провёл Бровь по узенькой лесенке на
        самый верх и вошёл в одну из безымянных дверей.</p>

      <p>Привычки стучаться за ним явно не
        водилось.</p>

      <p>Покорно проследовав, Бровь
        всё-таки врезалась в каменную таврскую спину: провожатый застрял на пороге.</p>

      <p>— Где Святотатыч? —&nbsp;гулко,
        как подземная палуба, спросил тавр.</p>

      <p>— Будет в течение часа, —
        ответили из помещения, — встречает корабль. А ты, как я вижу, с дарами.</p>

      <p>— Завкафа велено тут подержат’ пока.
        И ест’ ещё — как это говорят? — свидетельница.</p>

      <p>Так вот как звучит аутентичный
        таврский акцент.</p>

      <p>Весьма и весьма сурово. Твёрдо,
        прямо скажем. Смягчения согласных и поблажек раненым не предвидится.
        Остерегайтесь.</p>

      <p>— Щедро, — хмыкнул смутно
        знакомый голос, — сейчас отзвонюсь.</p>

      <p>Тавр наконец-то сдвинулся с
        мёртвой точки, позволив Брови юркнуть в помещение. После красот Порта её уже
        совершенно не удивило, что оно оказалось всего лишь небольшой комнаткой —
        низкий стол с телефоном, койка в углу и никаких вам больше мирских удобств.
        Стены, потолок и даже виднеющаяся из-под задрипанного ковра часть пола были
        испещрены бесконечными извивающимися орнаментами.</p>

      <p>Голова немедленно закружилась.</p>

      <p>Пока Бровь восстанавливала
        душевное и физическое равновесие, тавр водрузил тело на койку, передал
        служебную записку и пробирку (и когда он её сцапать успел?) отзванивающемуся и
        истаял, покинув подопечную на произвол судьбы.</p>

      <p>Отзванивающийся обернулся и,
        зажимая трубку плечом, приветливо и без удивления помахал Брови, ввиду чего она
        испытала беспрецедентное облегчение.</p>

      <p>Всё-таки не совсем на произвол.</p>

      <p>В разрисованной комнате находился
        Дима — друг Ройша из Медицинского Корпуса и первый человек за сегодняшний день,
        с которым можно было поговорить на ты. Кроме Гошки-Александра, разумеется.</p>

      <p>Тяжка участь того, кто общается с
        людьми вне своей возрастной категории.</p>

      <p>Тяжка участь главной героини
        шпионского романа.</p>

      <p>Дима же, хоть и был ровесником
        Ройша, медиком, условно серьёзным человеком в очках и при галстуке, всё равно
        неисправимо вызывал желание подкрасться сзади и хлопнуть его по спине
        подтяжками. Теми самыми, мимо которых ходишь в магазине и недоумеваешь, кто же может
        <i>это</i> купить. Да даже взять бесплатно.
        Да даже если очень попросят.</p>

      <p>Бровь ничего не имела против
        лилового цвета, но это ж надо — отыскать такой мерзостный оттенок.</p>

      <p>Лиловые подтяжки изящным завитком
        подчёркивали тот факт, что со спины Дима смутно напоминал Габриэля Евгеньевича
        —&nbsp;беспроглядно-чёрные и не лишённые седины (это
        в тридцать-то лет!) волосы делали своё дело.</p>

      <p>В рамках шпионского романа они
        просто обязаны переодеваться друг в друга.</p>

      <p>— Я так понимаю, всё прошло
        успешно и Габриэль Евгеньевич решил-таки скончаться, не вынеся бури страстей? —
        известив, по всей видимости, Лария Валерьевича об успехе тавра-таксиста в
        доставке объектов в Порт, Дима изучил пробирку на свет и небрежно шмякнул её на
        стол. Пробирка угрожающе покатилась и застыла неподалёку от края.</p>

      <p>— Не вынеся удара. Кулаком
        Максима Аркадьевича. —&nbsp;Бровь опасливо покосилась на пробирку. —&nbsp;Так
        что, это и есть оно?</p>

      <p>— Оно?</p>

      <p>— Ну, вирус. Страшная зараза,
        которую мне так важно было перехватить.</p>

      <p>— А!— Дима отправился изучить
        масштаб разрушений заведующего кафедрой истории науки и техники. — Я уж
        подумал, ты про сложные отношения верхушки преподавательского состава. Нет, в
        пробирке явно не вирус — скорее, продукты его распада. Второй или третьей
        стадии, не знаю. Оно и разумно: доверять тебе настоящую заразу с их стороны
        было бы как-то уж слишком. А так —&nbsp;обнаружить следы и доказать твою
        причастность было бы можно, а если бы ты, например, пробирку где-нибудь
        разбила, ничего смертельного бы не случилось.</p>

      <p>Какое жестокое разочарование.</p>

      <p>— Это ты на глаз определил?</p>

      <p>Дима, всё ещё осматривавший
        Габриэля Евгеньевича с удручающе профессиональным равнодушием, пожал плечами.</p>

      <p>— Попробуй догадаться, сколько я
        видел этого вируса в своей жизни, — он пристроил голову завкафа пофотогеничнее,
        запахнул его плащ и потянулся. — И потом, подумай сама. Следы заражения в
        унитазе Ройша — это, конечно, чудесно, но основная программа Бедроградской
        гэбни всё-таки состояла в том, чтобы вылить вирус в ныне объединённые
        канализацию и трубопровод. Чтобы в итоге зараза пошла из кранов. А для этого, —
        Дима нравоучительно воздел палец, —&nbsp;со стороны заразы было бы крайне мило
        быть незаметной. Например, прозрачной.</p>

      <p>Объединённые канализация и
        трубопровод — это… действительно злодейски со стороны Бедроградской гэбни.</p>

      <p>Хотя там, наверное, стоят
        какие-нибудь фильтры.</p>

      <p>И всё же, всё же.</p>

      <p>— Значит, не вирус, — Бровь
        поискала глазами, куда бы сесть, но единственным вариантом оказалось тело
        Габриэля Евгеньевича, — и не только это пошло не совсем так. Ещё, например, я
        не включила диктофон. То есть включила, но не то. Не спрашивай.</p>

      <p>Да, ей стыдно.</p>

      <p>Надо как-нибудь ненавязчиво
        переключить диалог на что-нибудь менее печальное.</p>

      <p>Или более!</p>

      <p>— Зато, —&nbsp;кого там
        интересовали сложные отношения преподавательской верхушки? — я узнала страшную
        тайну и готова ей с тобой поделиться. Габриэль Евгеньевич носит очки с простыми
        стёклами.</p>

      <p>Бровь, конечно, дала внутреннюю
        клятву не раскрывать этого никому, но Диме-то можно. Он вон тоже делился с ней
        своими кошмарными секретами — например, что его первым проектом в Медицинском
        Корпусе было создание какой-то штуки, которую можно намазать на корни волос,
        чтобы те временно перестали расти. Изобрёл он эту штуку исключительно для того,
        чтобы легко и удобно поддерживать у себя трёхдневную щетину.</p>

      <p>Когда-нибудь Диме откроется
        страшное знание: в его случае щетина не придаёт ни мужественности, ни
        серьёзности. И радикально не спасает окружающих от желания хлопнуть его подтяжками
        по спине.</p>

      <p>Возможно, даже провоцирует оное.</p>

      <p>— Простые очки Габриэля
        Евгеньевича — это не очень страшная не очень тайна, — хмыкнул Дима, — моя
        страшнее.</p>

      <p>С этими словами он стащил
        собственные очки и нацепил их на Бровь. Тоже простые, как и следовало ожидать.</p>

      <p>Может, они с Габриэлем
        Евгеньевичем всё-таки тайные братья?</p>

      <p>Один каждое утро явно укладывает
        чёлку на пол-лица, другой готов уехать в Столицу, чтобы, используя тамошние
        мощности, изобретать то, что позволило бы ему не бриться. И ещё этот
        Гошка-Александр с его бровями.</p>

      <p>Все кругом просто помешаны на
        своём внешнем виде. Один только Ройш — оазис равнодушия в буйстве
        самолюбования.</p>

      <p>Впрочем, что она на самом деле
        знает о тайной жизни Ройша?</p>

      <p>— На твоём лице очень
        выразительно написано, что ты по этому поводу думаешь, — Дима отобрал очки, —
        но, заверяю, это всего лишь производственная необходимость. Смотри.</p>

      <p>Он нагнулся и отодвинул чёлку —
        не на пол-лица, но тоже ничего такую. На переносице, прямо там, где обычно
        располагались очки, белел не слишком заметный, но всё же крайне опознавательный
        шрам.</p>

      <p>Сплошной!</p>

      <p>Шпионский!</p>

      <p>Роман!</p>

      <p>— В приличных книгах люди со
        шрамами выбивают двери ногой и курят сигары, — Дима вздохнул, — а мне пришлось
        надеть очки и уехать в Столицу. И ты думаешь, что в твоей жизни были настоящие
        разочарования.</p>

      <p>Кстати, когда он успел из своей
        Столицы вернуться?</p>

      <p>Не то чтобы Дима не мог вернуться
        откуда угодно когда угодно — Бровь не удивилась бы, если бы он в произвольный
        момент позвонил в дверь её квартиры (ну и что, что он там никогда не был и сейчас
        видит Бровь в лучшем случае раз пятый в жизни). Тем не менее, столкнуться с ним
        в Порту (где он делает, кстати, что?) было всё-таки неожиданно.</p>

      <p>Значит, как справедливо заметил
        Максим (Аркадьевич), началось.</p>

      <p>— Я только приехал,
        —&nbsp;поведал Дима, — вот сижу, жду звонка о состоянии дел из Медкорпуса.
        Активно не сплю и ничего о происходящем не знаю. Как происходящее?</p>

      <p>Как-как, без диктофонной записи,
        вестимо.</p>

      <p>— Ну как. Я убедительно
        поговорила с младшим служащим Александром, который оказался не Александром, а
        головой Бедроградской гэбни по имени Гошка. Он дал мне пробирку с вирусом,
        которая оказалась не с вирусом, а с какими-то там продуктами разложения. Я
        нажала на диктофоне кнопку записи, которая оказалась не кнопкой записи, а
        кнопкой перемотки вперёд. Всё вместе это вроде как означает, что они запустили
        свой злодейский план, и теперь мы поймаем их за руку, но… Я одна испытываю
        лёгкое подозрение, что и тут что-нибудь окажется чем-то не тем и пойдёт как-то
        не так? — Бровь сокрушённо покачала головой. — А, ну и Максим Аркадьевич ударил
        Габриэля Евгеньевича по лицу, чтобы тот ни о чём не догадался, а то ему вредно
        волноваться. А почему он, кстати, не приходит в себя?</p>

      <p>Это ведь точно никак не связано с
        тем, что Бровь выполнила наущение Охровича и Краснокаменного?</p>

      <p>— Слаб здоровьем. Кажется, на
        самом деле. Медицинские показатели Габриэля Евгеньевича — загадка природы,
        —&nbsp;часть Димы скрылась под столом в поисках сумки с сигаретами, — даже я бы,
        пожалуй, что-нибудь отдал за то, чтобы его препарировать.</p>

      <p>Видимо, услышав своё имя (и,
        разумеется, подгадав именно тот момент, когда присутствующие обсуждали, как он
        не приходит в себя), Габриэль Евгеньевич слабо застонал и попытался прийти в
        себя. Вот чего Бровь точно не хотела — так это общения с любимым завкафом. По
        крайней мере, сейчас и здесь. Кажется, добрая половина орнаментов на стенах
        символически изображала какую-то грязную порнографию.</p>

      <p>Все эти люди упорно забывают, что
        у них политика и смертельный вирус, а ей ещё когда-то экзамены сдавать.</p>

      <p>Всем этим людям.</p>

      <p>Ну, некоторым из них.</p>

      <p>Издав некий понимающий звук, Дима
        посмотрел на Габриэля Евгеньевича добрыми-добрыми глазами, ласково снял с него
        очки и свершил то, чему предначертано было свершиться уже аж в третий раз.</p>

      <p>Габриэль Евгеньевич испустил еле
        слышный вздох и вернулся в бессознательное состояние. Кажется, сегодня был не
        лучший день в его жизни.</p>

      <p>— Очень, <i>очень</i> давно хотелось, — удовлетворённо признался Дима и,
        последовательно исполняя ритуал, вернул очки на место.</p>

      <p>Абстрактные вселенские весы
        смотрели на происходящее с пониманием.</p>

      <p>Ради всеобщего блага и высокой
        цели.</p>

      <p>Это даже приятнее, чем
        рассказывать гадости про Ройша. Когда долго говоришь гадости, в какой-то момент
        невольно начинаешь в них верить. Вот, например, где сейчас Ройш? В
        Университете, на парах. И можно ли хоть на секунду усомниться в том, что перед
        выходом из дома он действительно проверил все карманы, все пуговицы и газовую
        колонку — вирус не вирус?</p>

      <p>В связи с чем очень хочется
        спросить, почему Бедроградская гэбня прицепилась именно к нему.</p>

      <p>— Бедроградская гэбня, Университетская,
        даже Портовая —&nbsp;всё шестой уровень доступа. А Ройш, внук хэра Ройша, имеет
        не только одно с ним лицо, но и право на второй уровень — как наследник
        Революции, —&nbsp;в отличие от Брови, Дима не стал сильно задумываться о том,
        куда лучше сесть, и плюхнулся прямо на пол. — И Бедроградская гэбня это знает.
        Не знает она того, что он за человек.</p>

      <p>Второй уровень доступа правда
        бывает, и его правда можно получить? Это же так… высоко. Одно дело — хэр Ройш
        на фотоснимке из отрядского учебника, и совсем другое — просто Ройш с портфелем
        и стопкой зачёток. Между ними, очевидно, есть связь, но, как бы это, реликварная.
        Ненастоящая. Не такая, которой можно на самом
        деле воспользоваться.</p>

      <p>Кстати, пора завязать с привычкой
        думать вслух. Не доведёт же до добра, ой не доведёт!</p>

      <p>— Взять второй уровень доступа —
        страшное оскорбление? — осторожно предположила Бровь, усаживаясь напротив Димы.
        Интересно, в Порту стулья отсутствуют принципиально?</p>

      <p>— Конечно. Получится ведь, что он
        имеет право знать и делать всё то, что знает и делает, да ещё и за счёт
        наследия великих предков. На такое он пойти не может.</p>

      <p>Предки-то, может, и правда
        великие, но это повод не восхищаться ими, а делать каменную физиономию на
        предмет хэра Ройша и говорить о нём преимущественно умолчаниями. Как и о том, что
        Ройш в самом деле имеет с ним одно лицо. И о том, что время от времени он
        вынужден читать лекции про собственного деда. Такое ощущение, что хэр Ройш
        сделал не Революцию, а гадость лично Ройшу.</p>

      <p>Он, впрочем, и сделал.</p>

      <p>Из-за известных народным массам и
        отрядским учебникам гардеробных предпочтений хэра Ройша Ройш теперь не может
        носить жилет — вдруг кто заподозрит его в недостаточном презрении к великим
        предкам. И в этом скрывается настоящая, подлинная драма: ясно же, что жилеты
        существуют исключительно для таких людей, как Ройш, ибо кому ещё может прийти в
        голову подобное на себя напялить.</p>

      <p>А теперь — из-за фамильного
        самолюбия — остались бедные жилеты одинокими и неприкаянными на этой земле.</p>

      <p>— Переживает за тебя?</p>

      <p>Переживает ли за неё Ройш? Этого
        никто не знает —&nbsp;по крайней мере, уж точно не Бровь.</p>

      <p>— А что, есть, по поводу чего
        переживать?</p>

      <p>Нервный смешок прибавился к
        реплике сам собой, Бровь его не планировала.</p>

      <p>Ведь, наверное, есть. Общение с
        головами Бедроградской гэбни и прочими смертельными вирусами — не самый
        безопасный род занятий. С другой стороны, всё ведь сложилось по плану, <i>по
          их собственному университетскому плану!</i> Ну, не считая диктофона.</p>

      <p>Бровь хотела сообщить, что всё
        было бы совсем хорошо, если бы она хоть что-нибудь понимала в происходящем, но
        из-за двери донеслись вопли слабой членораздельности, отдалённо напоминающие
        хохот.</p>

      <p>— Жопой клянусь, у него эти тюки
        по верхней палубе раскиданы. Вообще без палева.</p>

      <p>— Нашёл чем клясться!</p>

      <p>О, ещё кто-то идёт. Видимо, этот
        самый —&nbsp;как его — Святотатыч. Или вся Портовая гэбня. И войдут они,
        разумеется…</p>

      <p>— А граница с этого так прихуела, что нормального досмотра никто устраивать не
        стал. Ну и…</p>

      <p>…без стука.</p>

      <p>Сегодня день такой. День Входов
        Различных Людей в Различные Помещения без Стука.</p>

      <p>Всё нормально, шпионский роман
        должен начинаться с экспозиции, хотя когда ж она закончится-то, а.</p>

      <p>Бровь бегло проинспектировала
        ввалившихся на предмет шрамов, поскольку дверь они выбили очень даже ногой.
        Шрамов не обнаружилось. Дима же посмотрел на ввалившихся недоумённо и
        подозрительно. Видимо, его тоже опечалила такая несправедливость.</p>

      <p>Их было двое — значит, либо не
        гэбня, либо не вся гэбня, мудро постановила Бровь. Совершенно одинаковые,
        только один побольше, другой поменьше. В тельняшках (а как же иначе), с непьяно сверкающими глазами, серьгами в левых ушах (у того,
        который старше, аж до плеча, у второго поскромнее), нездоровым загаром и
        во-о-от таким размахом рук.</p>

      <p>Одинаковые.</p>

      <p>Как если бы Охрович и
        Краснокаменный были отцом и сыном.</p>

      <p>Вот именно этого и не хватало в
        её жизни!</p>

      <p>Вошедшие замолчали, вперившись в
        присутствующих. Присутствующие молчали, пялясь на вошедших.</p>

      <p>Благодать.</p>

      <p>— Ну здравствуй, Святотатыч, —
        медленно сказал Дима и не вставая полез за сигаретами. — И тебе привет.</p>

      <p>Тот, что поменьше, издал мычание
        низкой членораздельности, символизирующее, по всей видимости, светское
        удивление по-портовому. Вместе с полным непониманием происходящего.</p>

      <p>Тот, что побольше (то есть
        Святотатыч), по-хозяйски прошёл в комнату, изучил диспозицию и, зависнув над
        телом Габриэля Евгеньевича, обратился к своему спутнику:</p>

      <p>— У нас на берегу нынче большая
        политика. Не успел рассказать.</p>

      <p>Тот, что поменьше
        (Святотатыч-младший?), точно таким же хозяйским жестом отобрал у Димы пачку,
        закурил и переместился самостоятельно повисеть над телом Габриэля Евгеньевича. Дима
        отреагировал на акт хищения гробовым молчанием.</p>

      <p>Кажется, именно сейчас ему
        почему-то подумалось о том, что у Порта есть свои недостатки.</p>

      <p>— Передай Ларию: два-три часа на
        бумажки, потом я за девочку не отвечаю, — кивнул Святотатыч на телефон. Бровь
        почувствовала себя неприкаянной, аки жилет без Ройша.</p>

      <p>— Я кого-нибудь призову,
        —&nbsp;согласился Дима, который всё ещё гордо сидел лицом ко входу и спиной ко
        многочисленным святотатычам, — мне всё равно на
        телефоне торчать.</p>

      <p>— Дождёшься меня?</p>

      <p>Святотатыч-младший, к которому
        были обращены эти слова Святотатыча-старшего, ещё немного нечленораздельно
        помычал, явно не в силах решить, смотреть ему на разметавшегося по койке
        Габриэля Евгеньевича или на скорбящую по сигаретам спину Димы.</p>

      <p>Загадочный портовый язык.</p>

      <p>— Пройдёмте, — Святотатыч
        протянул Брови руку, легко поднял её с пола и весьма бесцеремонно подтолкнул в
        сторону двери. Всем бы такое рвение на государственной службе, и спасибо
        Охровичу и Краснокаменному за ценный опыт общения с опасными для жизни
        элементами.</p>

      <p>За спиной раздался трагический
        стон.</p>

      <p>Дима сидел на полу, закрыв лицо
        руками, и жаловался на жизнь на нечленораздельном портовом языке.</p>

      <p>&nbsp;</p>

      <p>Так часто поминать папино слабое
        сердце, наверное, дурная примета, но как же всё-таки хорошо, что он ничего о
        происходящем не знает. Спустившись на второй этаж, Святотатыч запихнул Бровь в
        комнатку, выполнявшую, видимо, функцию склада. По крайней мере, ящиков и самых
        настоящих бочек, от одного запаха которых начиналось похмелье, там было почти
        до потолка.</p>

      <p>На оставшемся клочке свободного
        пространства примостились три человека, и — о, это раньше Бровь думала, что
        Университетская гэбня какая-то странная. Поскольку представляться ей явно никто
        не намеревался, нужно было срочно их как-нибудь обозвать, чтобы не свихнуться
        от обилия новых знакомств.</p>

      <p>А вот где-то в Хащине сидит себе
        Галка, с которой можно выпить пива и потрепаться о том, как они провели лето и
        кто самый симпатичный в этом семестре. Сидит, ждёт Бровь — и не может
        дождаться, потому что Бровь заперлась в проспиртованной насквозь каморке с
        Портовой гэбней.</p>

      <p>Это уже не шпионский роман, это,
        честное слово, эпитафия.</p>

      <p>Первого из троих — в бандане,
        круглых цветных очках и с татуировкой на пол-лица — пусть зовут Рыжий, по цвету
        пламенеющих дредов. Второй —&nbsp;с копной
        тёмно-русых волос и мечтательным взором — Мундир, потому что чего может ожидать
        человек, нацепивший самый настоящий морской мундир? Третий —&nbsp;Головорез.
        Просто Головорез, хоть и ростом чуть повыше соседней бочки. И Бровь больше не
        будет смотреть в его сторону.</p>

      <p>А она ещё удивлялась
        тавру-таксисту!</p>

      <p>— Девочка, —&nbsp;декларативно
        указал Святотатыч на Бровь. — Показания девочки, — помахал он чистым листом
        бумаги и хлопнул им по бочке.</p>

      <p>Вышло громко.</p>

      <p>Как ни странно, в качестве
        пишущего предмета Святотатыч извлёк не перо, а обычную шариковую ручку, и
        выжидательно протянул её остальным. Головорез взял оную с недобрым ворчанием:</p>

      <p>— Показания, показания.
        Облажалась —&nbsp;пусть бы лучше отрабатывала, — и жадно зыркнул
        на Бровь.</p>

      <p>Не только у папы слабое сердце.</p>

      <p>Головорез, однако же, накорябал что-то в нижней части листа и передал ручку
        Мундиру. Тот мягко улыбнулся:</p>

      <p>— Ну куда ей отрабатывать, она же
        домашняя, — и вывел сложную завитушку.</p>

      <p>— Им там не приходило в голову
        научиться уже нормально работать? — недовольно прогнусавил Рыжий, но бумагу
        тоже подписал.</p>

      <p>— Курёхин уже с час как на якоре.
        Гружёный и нашим, и не нашим. А вы тут, —&nbsp;Святотатыч поставил последнюю
        подпись и убрал ручку в неведомые закрома.</p>

      <p>— Тем более, —&nbsp;сказал Рыжий.</p>

      <p>— Быстрее тут давай,
        —&nbsp;сказал Головорез.</p>

      <p>А Мундир ничего не сказал, только
        загадочно посмотрел на Бровь, после чего все трое покинули
        квартиру-комнату-склад-как-это-вообще-назвать.</p>

      <p>…Закрыв за ними дверь, Святотатыч
        придвинул Брови ящик для восседания, пристроился
        напротив и, покряхтев, вопросил:</p>

      <p>— Показания давать умеешь?</p>

      <p>— А это надо уметь? — Бровь
        сглотнула. — Я думала, мне просто нужно подробно рассказать, что было.</p>

      <p>— Кнопки вот тоже нужно <i>просто нажимать</i>, а выясняется, что это
        отдельное умение.</p>

      <p>Кнопок много, а произошедшего нет,
        но Бровь не стала говорить это вслух. Вместо этого она попыталась улыбнуться с
        извиняющимся видом. Вдруг под старой тельняшкой бьётся живое сердце?</p>

      <p>— Ладно, леший с кнопками, —
        Святотатыч закурил нечто вонючее, сделал не очень страшное лицо и вдруг
        заговорил совершенно нормальным человеческим голосом, полным сложносочинённых
        предложений. — Показания — это такое сочинение на условно свободную тему, в
        котором всё должно быть естественно и как бы невзначай, но с правильными
        акцентами. Чтобы те, кто будет это читать, могли самостоятельно сделать нужные
        выводы из сплошного потока фактов. Которые как бы невзначай. Ясно?</p>

      <p>Куда уж яснее.</p>

      <p>Историография — это, как
        говорится (на истфаке), скорее искусство, чем наука.</p>

      <p>— А какие акценты правильные —
        ясно?</p>

      <p>— Ну… что они плохие, а мы
        хорошие? Они пытались нас подставить, а мы догадались и пресекли?</p>

      <p>Святотатыч вытащил из закромов
        ещё одну самокрутку, с тоской обнаружил, что первая по-прежнему не докурена, и
        вздохнул. Его бесконечной длины серьга мелодично звякнула.</p>

      <p>— Это не акценты, это выводы
        —&nbsp;если их можно так назвать. А выводов в показаниях быть не должно.</p>

      <p>Бровь почесала в затылке. Этому
        дядьке сейчас нужно контрабанду разгружать с Курёхина, а он тут обучает её
        правописанию.</p>

      <p>Как-то неловко.</p>

      <p>— А что у моего Александра,
        например, волосы крашеные — это акцент?</p>

      <p>— Уже больше похоже, — Святотатыч
        улыбнулся и на мгновение стал совсем нестрашным, — важных акцентов всего три:
        сортир, Ройш и дружелюбие Александра. Оно же желание втереться в доверие, но
        так писать не стоит. Все прочие мелочи должны работать на эти три акцента. Крашеные
        волосы, как он вообще выглядел и как держался, куда водил, чем поил, о чём
        шутил шутки — это к дружелюбию. Чем оно важно, вроде должно быть понятно.
        Понятно, чем важны Ройш и сортир?</p>

      <p>— Ну, с Ройша всё началось. А ещё
        он университетский, но не имеет отношения к государственным структурам
        —&nbsp;по крайней мере, официального. Зато имеет личное. И, соответственно,
        может заним��ться делами, которые его не касаются. А ещё хуже, если в эти дела
        полезет его студентка, которая по собственной глупости и истеричности может
        устроить страшную заразу целому дому —&nbsp;чего не случилось бы, если бы
        Университет с самого начала разобрался с эшелонами власти и не
        попустительствовал. Так?</p>

      <p>— Вроде того. Из твоего сочинения
        на условно свободную тему должно быть ясно, что Александра крайне беспокоил
        лично Ройш, степень близости твоих контактов с Ройшем и, главное, этот
        злосчастный уровень доступа Ройша. А тебе, чтобы оное сочинение написать,
        должно быть ясно, что, будь у Ройша действительно второй уровень доступа, как
        предполагала Бедроградская гэбня, ей бы пришлось умерить свой пыл в стремлении
        нагадить Университету в сортиры. Шестому уровню доступа со вторым воевать
        бессмысленно.</p>

      <p>Ройш и второй уровень доступа,
        уму непостижимо. У него ведь всё немалое самолюбие построено именно на том, что
        он как бы никто, простой истфаковский преподаватель, а на деле почти всесилен.
        По крайней мере, в тех вопросах, которые решаются макулатурно-бюрократическими
        методами. Любой может делать то, что можно; Ройш может то, чего нельзя. Поэтому
        он никогда бы не сел ни в Университетскую гэбню, ни даже в секретари кафедры —&nbsp;какой
        уж там второй уровень!</p>

      <p>Высоко, очень высоко.</p>

      <p>Так высоко, что, может быть, там
        всё работает по каким-нибудь другим правилам.</p>

      <p>Но Ройш не любит другие правила,
        Ройш любит эти, и на всех неугодных он пишет исключительно скромные и
        официальные докладные. Ничего больше.</p>

      <p>Дождавшись гибели первой,
        Святотатыч наконец-то закурил вторую самокрутку.</p>

      <p>Сверху донёсся глухой удар и
        взрыв хохота.</p>

      <p>По-прежнему не лучший день в
        жизни Габриэля Евгеньевича.</p>

      <p>— А теперь скажи честно: ты
        понимаешь, при чём здесь сортиры?</p>

      <p>— Если это не очередная сплетня,
        а Университет на самом деле владеет всеми городскими канализациями, то скорее
        да. Хорошо бы не было сплетней. Есть же у нас свой бордель, почему сортирам
        города не быть тоже нашими?</p>

      <p>— Ваши они, ваши. Кроме портовых.</p>

      <p>А Габриэль Евгеньевич — на самом
        деле дух, и удар наверху был вовсе не по нему.</p>

      <p>— Но зачем? Почему Университет
        заведует городскими сортирами?</p>

      <p>Святотатыч тяжко вздохнул. Бровь
        сжалась.</p>

      <p>Возможно, сейчас не время и не
        место для подобных вопросов. И для вопросов вообще. Она же не записала
        разговор, она отвлекает старого моряка (без махорки) от контрабанды, у него нет
        времени на всякие глупости —</p>

      <p>— Потому что это весело,
        —&nbsp;бесстрастно бухнул Святотатыч и подмигнул, снова расплываясь в улыбке, —
        сколько тебе лет?</p>

      <p>— Девятнадцать.</p>

      <p>— Девятнадцать… ну вот, значит,
        когда тебе было одиннадцать, а Университетской гэбне — меньше года, они
        поцапались с гэбней Бедроградской. По поводу бюрократических и фактических
        полномочий. История простая, но драматичная: Университетская гэбня
        только-только разобралась, что она может по бумажкам, едва приступила к разбору
        того, что может на самом деле, а тут Бедроградская вздумала посадить студента. Истфаковского, с этой вашей кафедры. </p>

      <p>Наверху раздались звуки
        перетаскивания чего-то тяжёлого. Эдак шестидесятикилограммового. С этой нашей
        кафедры.</p>

      <p>— Ничего шибко криминального там
        не было, глупое обвинение в поиске и последующем хранении информации более
        высокого уровня доступа, чем у студента имелся. Информация, правда, на тот
        момент была значимая и даже скандальная, но отмазать всё равно могли —
        присвоить задним числом звание младшего служащего, рассказать сказку, что
        информация добывалась и хранилась по прямому приказу Университетской гэбни.
        Могли и не отмазали, потому что не успели. В общем, пока соображали, как это
        всё технически осуществить, спрятали студента на частной квартире. А
        Бедроградская гэбня как единица управления всем городом, кроме Порта, имеет
        право на любую частную квартиру заявиться с обыском. Дальше всё понятно:
        заявились, обыскали, посадили. Обидно вышло. Но ещё обиднее, что буквально
        через несколько дней Бедроградская гэбня захапала ещё одного университетского
        человека — на этот раз незаконно. У Университетской же на тот момент никаких
        возможностей куда-либо в Бедрограде заявляться и обыскивать не было. И вот по
        результатам всего этого веселья захотелось им такую возможность поиметь.</p>

      <p>— А что есть в каждом доме?
        Конечно, сортир! — радостно перебила Бровь. — Если заполучить сортиры, можно в
        любой момент заявиться и обыскать унитазы. Ну и не только, наверное. Хитрая
        идея. Охренеть.</p>

      <p>— Ну какое же это охренеть? Это
        обыкновенный неповторимый стиль Университета.</p>

      <p>А ещё на кафедре висит чучело
        Вени.</p>

      <p>Бровь неожиданно ощутила страшную
        гордость за своё учебное заведение.</p>

      <p>Святотатыч порылся в закромах в
        поисках следующей самокрутки. В его возрасте —&nbsp;под пятьдесят, а то и за —
        не слишком-то полезно смолить одну за одной. Сколь бы старой ни была тельняшка,
        от этого всё равно случается рак мозга.</p>

      <p>Папа Брови — доктор медицинских
        наук, у неё детская травма.</p>

      <p>— Городскую канализацию
        отвоёвывали академическими методами, от которых Порт далёк. Вроде как она
        сделана по проекту этого вашего основателя Университета. Аргумент это или нет,
        ещё пойди разбери, но, в общем, отвоевали. Бедроградская гэбня утёрлась. То
        есть все думали, что утёрлась, а теперь выясняется, что её на канализации
        заело. Семь злосчастных лет под покровом ночи и по колено в говне Бедроградская
        гэбня перестраивала городскую канализацию. Втайне.</p>

      <p>Александру пошло бы говно по
        колено. Как раз в тон к симпатичной замшевой куртке.</p>

      <p>— Грамотно перестраивала, как раз
        в неповторимом университетском стиле. Есть такая байка, что этот ваш основатель
        Университета, водивший знакомство с чернокнижниками и прочими светилами науки
        своего времени, под собственными владениями обустроил совсем уж волшебную
        канализацию. С безотходным оборотом веществ, чтобы не зависеть от городской
        подачи воды.</p>

      <p>Объединённые канализация и
        трубопровод!</p>

      <p>Выходит, злодейский план вылез аж
        из проектов Йихина?</p>

      <p>— Якобы у него утром из крана
        текло то, что вечером спустили в сортир —&nbsp;за ночь претерпев магические
        изменения под действием чернокнижных штучек. Короче, Бедроградская гэбня
        озадачила своих инженеров, и те за семь лет породили-таки что-то подобное. Там
        всё гораздо сложнее и оборот веществ не безотходный, но определённое сходство
        есть. Часть воды из сортиров действительно проходит очистку за довольно
        короткий срок и возвращается в краны — нормальной питьевой водой. И из чистой
        зловредности Бедроградская гэбня собирается приписать своё чудо техники
        Университету. Якобы Университет чудо техники придумал, тайно воплотил и тайно
        же начал испытания на живых людях, живых домах и живых сортирах. Без
        согласования с властью города — то есть с Бедроградской гэбней. И якобы
        безголовая студентка, дочка профессора-вирусолога из Университета и дама сердца
        профессора-зануды из Университета же, прослышав об испытаниях чуда техники,
        безголово и истерично слила в сортир своему профессору-зануде неведомо какую
        заразную дрянь, с которой системе очистки справиться не удалось. И целый дом
        заболел, потому что Университет не справляется, потому что Университет не
        информирует о своих проектах городскую власть, но информирует студенток,
        безголовых и истеричных. А никакого младшего служащего Александра и в помине не
        было, всё это оправдательный бред студентки. Который пойди ещё подтверди без
        аудиозаписи встречи с Александром.</p>

      <p>Святотатыч задумчиво звякнул
        длиннющей серьгой, в очередной раз порылся в закромах, извлёк самокрутку и
        протянул её Брови.</p>

      <p>У неё папа — доктор медицинских
        наук. И не следует брать у малознакомых дядек всякую гадость. Но с другой
        стороны — вдруг это местный ритуал дружелюбия, и отказаться означает навеки
        заклеймить себя?</p>

      <p>И когда ей ещё настоящую портовую
        самокрутку дадут.</p>

      <p>А вообще это всё какое-то
        безумие. Приписать плоды собственного семилетнего труда Университету и попытаться
        заразить целый дом смертельным
        вирусом только для того, чтобы доказать, кто здесь правее, — слишком долго для
        истерики, слишком сумасшедше для последовательного боевого плана. Разве что
        масштаб соответствует уровню доступа.</p>

      <p>И, главное, чего они прицепились?
        Что бы там ни было восемь лет назад, Университет давно уже никого не трогает,
        занимается себе наукой и выпускает студентов.</p>

      <p>Ну то есть Бровь так полагала.</p>

      <p>Наверху над телом Габриэля
        Евгеньевича явно совершали какие-то кошмарные манипуляции.</p>

      <p>— Но ведь у нас есть пробирка с
        вирусом —&nbsp;то есть, если верить Диминому глазу, какими-то там продуктами
        его разложения. Ну и я — я могу не только показания дать, но и опознать,
        например. Это ведь доказательства?</p>

      <p>«Якорь — тоже хуй».</p>

      <p>Правый рукав тельняшки
        Святотатыча был закатан до локтя, обнаруживая заковыристую татуировку,
        выполненную, кажется, тем же мастером, что и узоры на стенах этажом выше.</p>

      <p>Так вот, Бровь наконец-то сумела
        её прочитать.</p>

      <p>Кажется, предположение о порнографичности содержания стен подтвердилось.</p>

      <p>Святотатыч перехватил её взгляд и
        усмехнулся:</p>

      <p>— Ну да. Показания, опознания —
        тоже доказательства. В некоторой степени, — положил на бочку неведомо откуда
        взявшуюся стопку белых листов и нравоучительно ткнул в них грубым пальцем. —
        Дружелюбие, Ройш, сортиры.</p>

      <p>Первый вариант очень честного
        сочинения на вольную тему с правильно расставленными акцентами Святотатыч
        забраковал. Второй — тоже. После третьего он, крякнув, заявил, что писать
        придётся вместе, только он сперва перекурит.</p>

      <p>Бровь вздохнула.</p>

      <p>— Здравствуйте, Габриэль
        Евгеньевич, — поприветствовал Святотатыч пространство за её спиной. Она
        подпрыгнула, обернулась и никого не обнаружила.</p>

      <p>Ах да, он же дух.</p>

      <p>Портовые дядьки умеют видеть духов
        и в совсем бестелесной форме?</p>

      <p>Святотатыч тем временем извлёк из
        закромов веточку не то укропа, не то савьюра, не то чего-то ещё более
        запрещённого —&nbsp;Бровь не знала толком, как выглядит это самое запрещённое,
        но воняло оно не очень укропно — и вплёл в серьгу.
        Вышло весьма органично, поскольку серьга и так состояла из интригующе
        извивающихся колец, верёвочек, обрывков тесьмы, цепочек, мелких камней разной
        степени драгоценности и просто каких-то бессмысленных металлических бляшек.</p>

      <p>Окончательно потерявший тело
        (возможно, в ходе бесчеловечных манипуляций этажом выше) дух Габриэля
        Евгеньевича и укроп в серьге.</p>

      <p>И счастливо спасённый от
        смертельного вируса дом Ройша.</p>

      <p>Отличный выдался денёк.</p>

      <p>—&nbsp;Вы сегодня уже жрали,
        —&nbsp;проворковал Святотатыч, — в вашем возрасте столько жрать не положено.
        Поэтому, простите, на обед только зелень.</p>

      <p>Под его тельняшкой что-то
        зашевелилось и поползло в направлении серьги.</p>

      <p>Хочется верить, что это не
        какая-нибудь чересчур вольная часть тела.</p>

      <p>— <i>Только</i> зелень. Габриэль Евгеньевич, всем же давно известно, что,
        оставаясь в одиночестве, вы всё равно жрёте всякую грязь с земли, наплевав на
        диету.</p>

      <p>Голос Святотатыча трепетал,
        переполненный нежностью.</p>

      <p>Из ворота его тельняшки высунула
        усы толстая чёрная крыса с благородной сединой вдоль хребта, деловито обнюхала святотатычевскую бороду, одобрила её состояние и приступила
        к разграблению серьги с видом предельно занятого существа. На Бровь она
        презрительно повела ухом и тут же забыла о её существовании.</p>

      <p>Нельзя не признать некоторого
        сходства.</p>

      <p>В гастрономическом раже крыса
        Габриэль Евгеньевич выронила огрызок укропной веточки и посмотрела на
        Святотатыча с укоризненной требовательностью. Святотатыч со вздохом нагнулся и
        вернул пищу грызуну.</p>

      <p>Ощутимого сходства.</p>

      <p>Бровь не удержалась и захихикала.</p>

      <p>— Не смейся, — приказал
        Святотатыч. —&nbsp;Он обидчив, но, в отличие от прототипа, способен перегрызть
        обидчику глотку.</p>

      <p>А за настоящего Габриэля
        Евгеньевича это по необходимости сделает Максим (Аркадьевич). Если не будет
        слишком занят избиением крысиного прототипа.</p>

      <p>Нельзя также не заметить, что
        непредвзятая Портовая гэбня, кажется, по уши в университетских делах. Знать в
        деталях историю с канализациями — это одно, а вот назвать крысу в честь завкафа
        — это как-то… интимно.</p>

      <p>Хотя, может, и у Александра дома
        живёт какой-нибудь там аксолотль со звучным именем Охрович-и-Краснокаменный. И Александр
        нежно гладит его за жабрами перед тем, как отправляться на дело —&nbsp;в ночь,
        в канализацию, в говно.</p>

      <p>Крыса Габриэль Евгеньевич
        серьёзно пошевелила усами, напоминая Брови, что показания ещё не зафиксированы.</p>

      <p>Та покорно вернулась к своим
        попыткам освоить нелёгкое дело расстановки акцентов.</p>

      <p>&nbsp;</p>

      <p>Удалось ей раз на седьмой или
        восьмой. Придирчиво перечитав многочисленные высокохудожественные конструкции,
        Святотатыч позволил наконец переписать их на чистовик, не забывая отслеживать
        размашистость почерка —&nbsp;с тем, чтобы на последней странице текст аккуратно
        и достоверно заканчивался ровно над подписями Портовой гэбни. На чём дача
        показаний, кажется, таки закончилась. Бровь выдохнула и утёрла трудовой пот.</p>

      <p>— Выучи наизусть на всякий
        случай. Если всё сложится удачно для Университета, придётся повторять живьём перед
        лицами более высокого уровня доступа.</p>

      <p>Как будто Бровь и так не выучила.
        В качестве домашнего чтения у неё есть семь или восемь черновиков, на
        порождение которых по внутреннему ощущению ушло двое-трое суток. А Курёхин всё
        стоит, а контрабанда всё ждёт.</p>

      <p>— Сколько мы тут просидели? А то
        у вас же там корабль —&nbsp;с вашим и не вашим.</p>

      <p>С некоторой долей вероятности её сейчас
        не убьют за напоминание.</p>

      <p>Святотатыч хмыкнул.</p>

      <p>— У меня там, — ткнул пальцем в
        потолок, — человек с корабля. И правда, давно сидим, пора возвращаться.</p>

      <p>Ах да, Святотатыч-младший.</p>

      <p>— Человек с корабля — это ваш
        сын?</p>

      <p>Святотатыч выкатил на неё глаза,
        загоготал и помахал перед носом Брови узорчатым татуированным якорем на правой
        руке.</p>

      <p>Тем самым, который тоже хуй.</p>

      <p>Сын, видимо, названый.</p>

      <p>О перипетии нелёгкой портовой
        жизни!</p>

      <p>&nbsp;</p>

      <p>Перипетии нелёгкой портовой жизни
        снова вели наверх, в разрисованную комнату.</p>

      <p>— Оригиналу записи место в
        Университете, в кафедральном сейфе. Порт — нейтральная территория, мы не можем
        просто каждый раз ездить сюда за всем, что нам понадобится.</p>

      <p>…В разрисованную комнату с
        удручающе плохой звукоизоляцией, не скрывавшей раскатистого голоса Максима
        (Аркадьевича). Который, видимо, приехал за Бровью и прочими безжизненными
        телами.</p>

      <p>И записью. Какой записью, Максим
        (Аркадьевич), разве все мы здесь сегодня не потому, что записи не сложилось?</p>

      <p>Или он <i>не</i> о диктофоне Брови?</p>

      <p>— Тут безопаснее, но дело твоё.
        Только по всем производственным вопросам —&nbsp;к Святотатычу. А я так,
        временно сошёл на берег.</p>

      <p>— Сейчас не помешала бы любая
        помощь. Бюрократия более-менее схвачена, но рук всё равно не хватает. Хотя это,
        наверное, уже не по адресу.</p>

      <p>Момент для беседы со
        Святотатычем-младшим Максим (Аркадьевич) выбрал не самый лучший, ибо картина,
        открывшаяся глазам Брови при входе в комнату, была воистину устрашающей.</p>

      <p>Габриэль Евгеньевич по-прежнему
        лежал на койке, прикрытый плащом Максима (Аркадьевича) так, что даже
        неискушённому девятнадцатилетнему наблюдателю становилось очевидно отсутствие
        на нём любой другой одежды. На это также смутно намекал тот факт, что
        приснопамятная кружевная рубашка стоимостью в годовую стипендию небрежно
        свисала с пояса Святотатыча-младшего, который лишился тельняшки, зато обзавёлся
        сделанным из ясно чьего тонкого кожаного ремня ошейником. Вся прочая одежда
        заведующего кафедрой истории науки и техники, доктора исторических наук и
        просто уважаемого человека свисала с Димы. Так он эмпирически доказал,
        например, что из плаща получается неплохой тюрбан, брюки вполне можно повязать
        на шею как бант, а ботинки, эээ, прицепить шнурками к
        запястьям?</p>

      <p>— Это вериги, — мутно пояснил
        Дима, — я турко-греческий царь в изгнании.</p>

      <p>— Устыдись! Турция-Греция —
        демократическое государство, — похлопал его по плечу Святотатыч-младший, — так
        что ты либо древний турецкий царь, либо обычный древнегреческий пиздобол, то
        есть аристократ.</p>

      <p>— Ложь, — Дима замахал веригами,
        —&nbsp;я молод, современен и хорош собой. Потому и в изгнании.</p>

      <p>Судя по разбросанным по всему
        столу картам, в разрисованном притоне велась азартная игра на раздевание
        Габриэля Евгеньевича. Судя по количеству валяющихся по полу бутылок, успешно.</p>

      <p>Достаточно успешно, чтобы счёт
        записывался на обороте служебной записки, а пробирка с продуктами разложения
        второй или третьей стадии служила в качестве пресс-папье и была трогательно
        наряжена чьим-то кольцом. Интересно, чьим? Точно не габриэль-евгеньевичевским,
        он бы никогда не стал носить нечто столь задрипанное, пусть и серебряное, пусть
        даже с чёрным треугольным камнем.</p>

      <p>Хмуро подпиравший стену Максим
        (Аркадьевич) созерцал всё это без ожидаемой боли. Будучи апологетом
        неподражаемого стиля Университета, он, наверное, в глубине души чувствовал себя
        как дома. И, наверное, завидовал. Этим-то двум типам самое время подружиться на
        почве недавнего прибытия, надраться и горя не знать, а у Университета — то есть
        во многом лично у Максима (Аркадьевича) — Большая Политика.</p>

      <p>Так оно всегда и бывает. Пока
        ничего (или почти ничего) не ведающие смертные раздевают завкафов и носят
        вериги, кому-то надо вершить судьбы мира. Кому-то надо говорить с Александрами
        и забывать включать диктофоны, чтобы потом подвергнуться смертельной опасности
        и расхохотаться ей в лицо.</p>

      <p>И пусть это не будет опасность
        повторной дачи показаний.</p>

      <p>— Господин Главнокомандующий,
        получите из рук в руки, —&nbsp;Святотатыч ткнул листы с сочинением на условно
        вольную тему в руки Брови, а её саму — в руки к Максиму (Аркадьевичу). — Что же
        касается оригинала записи, которую вы тут обсуждали на весь этаж, в Университет
        ей пока рановато. Всё равно никакого юридического веса она не имеет. И
        хранится, разумеется, не здесь. Ходить далеко.</p>

      <p>— Оригинал записи может
        потребоваться в течение суток, — не забыв ободряюще улыбнуться Брови, Максим
        (Аркадьевич) снова нахмурился. — Я отвезу Бровь и Габриэля Евгеньевича по
        домам, к ночи вернусь на кафедру. Тогда и отправим запрос на расследование. А
        как работают лица более высокого уровня доступа, вы знаете — может понадобиться
        любая информация. Не хотелось бы ездить за ней в Порт. Вам же не меньше нашего
        дорого представление о Порте как о нейтральной территории, а что и где
        хранится, они легко узнают.</p>

      <p>— Ну, это только если их не
        прирежут прямо за воротами, когда сунутся узнавать. Порт — нейтральная
        территория <i>вообще</i> во всех отношениях.
        Портовая гэбня контролирует Порт, а не портовое население с портовыми ножами.</p>

      <p>От окна повеяло замогильным
        хладом.</p>

      <p>Дима и Святотатыч-младший,
        прервавшие было свои забавы, чтобы послушать серьёзные разговоры, вернулись к
        картам. Поразмыслив немного, крыса Габриэль Евгеньевич лихо соскочила со святотатычева плеча и присоединилась к ним.</p>

      <p>Максим (Аркадьевич) отклеился от
        стены.</p>

      <p>— Понимаю. В любом случае,
        спасибо, — он покосился на картёжников, — от лица Университета.</p>

      <p>Картёжники синхронно кивнули, не
        отрываясь от своего судьбоносно важного занятия. Святотатыч задумчиво почесал
        серьгу.</p>

      <p>Серьга бренькнула.</p>

      <p>— Звони, если таки понадобится.
        Переправим запись за час своими силами.</p>

      <p>Кажется, всеобщие мир и согласие
        были наконец-то достигнуты. Максим (Аркадьевич) уже почти протянул Святотатычу
        руку на прощание, когда крыса Габриэль Евгеньевич решила, что слишком долго
        таилась в тени, и вернула себе свет софитов. Умело вцепившись зубами в
        салфетку, она схватила пробирку с продуктами разложения и всё так же лихо
        сиганула со стола. Если бы не кольцо, которым её давеча принарядили, тут бы и
        закончилась жизнь потом и коньяком добытой пробирки, поскольку ничем больше
        салфетка к ней не крепилась.</p>

      <p>— Вирус! — возопил Максим (Аркадьевич)
        и ринулся в погоню.</p>

      <p>— Не вирус, а… кольцо! — Дима
        бросился следом, и уже с лестницы донеслось: — Мы не закончили его разыгрывать!
        Не пытайся править моей судьбой, четвероногое!</p>

      <p>Далее раздался грохот.</p>

      <p>Возможно, бегать по лестницам в
        тюрбане — не лучшая охотничья стратегия.</p>

      <p>Святотатыч посмотрел на
        Святотатыча-младшего с непроницаемым лицом — настолько непроницаемым, что Бровь
        немедленно заподозрила его тайный умысел и участие в произошедшем. Крысы,
        например, бывают дрессированными.</p>

      <p>— Сын мой, — услышав обращение,
        Святотатыч-младший подпрыгнул и обернулся к названому отцу с глубокими
        сомнениями на лице. Удовлетворённый эффектом, тот продолжил, — не хочешь
        приобщиться к прекрасному?</p>

      <p>Святотатыч широким шагом подошёл
        к койке и жестом Александра, предлагающего выпить ещё по стопочке, снял с
        Габриэля Евгеньевича очки.</p>

      <p>Кажется, новоиспечённая добрая
        кафедральная традиция грозила сделаться недоброй и портовой.</p>

      <p>— Обижаете, <i>папаша</i>, — ядом, вложенным в последнее слово, можно было отравить не
        один дом Ройша, а весь Бедроград, — я уже.</p>

      <p>Бровь мысленно одобрила свои
        дедуктивные навыки.</p>

      <p>Святотатыч пожал плечами (серьга
        снова звенькнула), бережно взял тело Габриэля
        Евгеньевича за затылок и, сделав драматическую паузу, нанёс свой удар.</p>

      <p>Между прочим, подобное обращение
        и привыкание может вызвать.</p>

      <p>Очки вернулись на круги своя,
        делая преступление идеальным и нераскрываемым. С
        учётом того, что синяки на бледной коже Габриэля Евгеньевича проступать
        по-прежнему отказывались, догадаться, кто и сколько раз его, бедного, бил, было
        невозможно.</p>

      <p>Что опять-таки наводит на вопрос.</p>

      <p>— А откуда вы знаете, что в этом
        сезоне модно применять к Габриэлю Евгеньевичу физические воздействия?</p>

      <p>— Порт кормится слухами, —
        невинно хмыкнул Святотатыч, — они здесь самая страшная сила, не чета портовым
        ножам.</p>

      <p>С лестницы снова донёсся шум.
        Честное слово, как здесь вообще можно жить с такой слышимостью?</p>

      <p>— …второй или третьей стадии
        разложения. Точнее без совсем уж специализированной аппаратуры сказать
        невозможно, да и не надо: заниматься полным анализом — дело фаланг.</p>

      <p>— Уверен?</p>

      <p>— За кого ты меня держишь? Вы же
        пробирку прислали, чтобы я на неё посмотрел и убедился. Я посмотрел и убедился.
        — Дверь открылась. — Всё идёт по плану.</p>

      <p>Наверное, когда Максим
        (Аркадьевич) давал указания, стоило уточнить, что посмотреть предполагается не
        на свет, а, ну, в микроскоп хотя бы, который наверняка есть в Порту, потому что
        в Порту по наблюдениям Брови было всё.</p>

      <p>Охотники вернулись с успехом:
        Максим (Аркадьевич) аккуратно держал завёрнутую в обжёвок
        салфетки пробирку, а Дима не потерял свой тюрбан. И, кажется, даже отвоевал
        кольцо. Интересно, у кого из участников погони.</p>

      <p>— Да пусть бы оно и сгинуло тут,
        на лестнице, — тихо покачал головой Святотатыч-младший, изучая свои карты.</p>

      <p>Вероятно, он проигрывал.</p>

      <p>&nbsp;</p>

      <p>Обратно из Порта Бровь вёл уже
        Максим (Аркадьевич) — и весьма убедительно вёл, всего пару раз засомневавшись
        на повороте. Наверное, голова гэбни должен уметь всё. Например, нести на руках
        завёрнутого в плащ Габриэля Евгеньевича и продолжать при этом выглядеть
        серьёзно и даже немного устрашающе. Достаточно устрашающе для того, чтобы
        закурить Бровь решилась только при виде тавра-таксиста, ожидавшего их у
        незнакомых покосившихся воротец. От Святотатыча они шли, само собой, не той же
        дорогой, что к нему, в шпионских романах иначе не бывает. А ещё в шпионских
        романах выйти из злачного места, не закурив местную же самокрутку, — преступно.</p>

      <p>Поскольку дорога была не та же и
        шлагбаума не случилось, Бровь догадалась о том, что они выходят из Порта,
        только при виде тавра-таксиста. Пришлось спешно (и, к счастью, успешно) искать
        самокрутку в кармане сумки.</p>

      <p>Это выглядело <i>круто</i>.</p>

      <p>Это не могло не выглядеть <i>круто</i>.</p>

      <p>Бровь мысленно одобрила святотатычевскую щедрость и свою запасливость.</p>

      <p>И даже не закашлялась, хоть и
        было, от чего.</p>

      <p>Максим (Аркадьевич) никак не
        отреагировал на это героическое и <i>такое крутое</i> действие, зато Габриэль
        Евгеньевич, учуяв дым, поморщился, открыл глаза и тут же их закатил. Нет
        никакой совести у этого человека. Ароматы Порта — это мелочь, не стоит обращать
        внимания и приходить в себя, зато запах табака —&nbsp;и то быстро уносимый
        ветром — это, конечно, страшное преступление.</p>

      <p>Осознав, что от закатывания глаз
        вселенная не спешит принципиально меняться, Габриэль Евгеньевич поднял голову,
        холодно посмотрел на Бровь и обратился куда-то налево:</p>

      <p>— Если моё мнение вообще может
        иметь хоть какое-то значение, замечу, что предпочёл бы передвигаться на своих
        ногах, — и, помолчав, добавил, — если они, конечно, ещё на месте.</p>

      <p>Интересно, что он помнит о
        произошедшем? Вот очень хорошо бы было бы, если бы не свой путь до Порта и
        связанные с ним события. Остальное, в сущности, мелочи.</p>

      <p>— Как угодно, — Максим
        (Аркадьевич) остановился, — но ботинок на месте нет.</p>

      <p>Габриэль Евгеньевич потёр висок.</p>

      <p>Вот Ройшу ломать пальцы
        бессмысленно — они для него всего лишь часть образа, а не средство
        коммуникации. А у Габриэля Евгеньевича потирание виска — стандартный ответ на
        половину реплик. Особенно хорош на экзамене. Особенно когда спрашиваешь у него,
        за что же четвёрка.</p>

      <p>Бровь злорадно затянулась.</p>

      <p>Максим (Аркадьевич), который с некоторой
        вероятностью различал интонации стандартного ответа Габриэля Евгеньевича,
        опустил его босыми ногами на землю. Тот поёжился, окатил своего верного
        носителя ещё одной волной ледяного взора, продел руки в рукава плаща, завязал
        пояс и решительно направился к такси. Вся его фигура была отличной иллюстрацией
        к словарной статье на слово «зябко».</p>

      <p>Один сидит в отвоёванных веригах,
        другой из-за этого уходит из Порта босиком.</p>

      <p>Они точно тайные братья.</p>

      <p>Но как? Как можно получить по
        лицу от своего, гм, заместителя, очнуться вечером неизвестно где среди серых
        складских стен в компании его же и какой-то произвольной студентки, обнаружить
        на себе из одежды только чужой плащ, а из жизненных перспектив — только
        тавра-таксиста и ничего — ни-че-го! —&nbsp;не
        спросить? Ну хотя бы —&nbsp;«а кто ещё меня сегодня бил по лицу?» Или там
        —&nbsp;«извините, вы не подскажете, мои трусы не являются украшением тюрбана
        какого-нибудь изгнанного турко-греческого царя?»</p>

      <p>Или —&nbsp;«Максим, что
        происходит?»</p>

      <p>Вышла бы такая проникновенная
        сцена.</p>

      <p>Какая жалость, что Габриэль
        Евгеньевич готов идти босиком по холодной сентябрьской грязи, лишь бы не
        уронить достоинство. Достоинство, покрытое гусиной кожей, выглядит не очень
        достойно.</p>

      <p>Бровь мысленно не одобрила
        качество своего чувства юмора.</p>

      <p>В любом случае, грех жаловаться.
        Даже без проникновенной сцены Бровь только что увидела босого завкафа в плаще
        растерянного замзавкафа. После такого и умирать не
        страшно.</p>

      <p>Тавр-таксист зашевелился.
        Многоопытная Бровь, перенесшая без потерь встречу с Портовой гэбней, теперь
        сочла его вполне милым и приятным человеком, с которым совсем не страшно
        повстречаться вечером у склада. Папино слабое сердце может спать спокойно.</p>

      <p>Подтверждая только что обретённую
        репутацию милого и приятного человека, тавр-таксист распахнул перед Габриэлем
        Евгеньевичем заднюю дверь. Тот проникновенно заглянул ему в глаза,
        демонстративно обошёл такси и не менее демонстративно уселся вперед.</p>

      <p>Отлично.</p>

      <p>Вот если чего сегодня Брови в
        жизни и не хватало, так это сидеть всю обратную дорогу плечом к плечу с
        Максимом (Аркадьевичем), на всепоглощающий хлад Габриэля Евгеньевича реагирующим
        как студент на дополнительные вопросы. Его студентом он когда-то и был,
        собственно.</p>

      <p>Такие мелочи Оставляют Отпечаток.</p>

      <p>Максим (Аркадьевич) посмотрел на
        Бровь извиняющимися глазами, как будто она только что стала свидетельницей
        домашней сцены. Пришлось снисходительно кивнуть — мол, понимаю, вам выпала
        нелёгкая участь быть хранителем душевного благосостояния непростого человека в
        непростой ситуации, которую вы и заварили, но это ничего, всё равно понимаю.</p>

      <p>В такси по-прежнему играла
        Кармина Бурана. Вкусы тавров непредсказуемы, но не очень разнообразны.</p>

      <p>Таксист поковырялся под сиденьем
        и протянул Габриэлю Евгеньевичу извлечённый оттуда плед. Габриэль Евгеньевич убийственно
        на него прищурился, опустил стекло (чтобы градус хлада не падал, то есть не
        поднимался, то есть, короче, чтобы у Брови мгновенно замёрзли ноги) и
        отвернулся.</p>

      <p>Так и поехали.</p>

      <p>— Давай менее конспиративными
        путями, —&nbsp;обратился Максим (Аркадьевич) к тавру, покачав головой на
        поджатые ноги Брови. — Сегодня был тяжёлый день.</p>

      <p>Габриэль Евгеньевич издал звук
        невнятного презрения и выкрутил Кармину Бурану на максимальную громкость.</p>

      <p>Тяжёлый? Только если «тяжёлый» на
        самом деле означает «самый охренительный в жизни»!
        Бровь побывала в Порту, узнала многие тайны, увидела многих людей,
        познакомилась с крысой Габриэлем Евгеньевичем —&nbsp;и это во второй половине
        дня, а с утра она говорила с самим мозговым центром безумных планов
        Бедроградской гэбни, зловещим Александром, и перехитрила его, забыв только
        включить диктофон, и теперь Святотатыч говорит, что из-за этого может сложиться
        так, что безумные планы доказать не получится, и дом Ройша могли на самом деле
        заразить, и вдруг Бровь всё-таки сумеют в этом обвинить, или, чего лучше,
        уберут свидетеля, или возьмут в заложники и съедят…</p>

      <p>Сегодня был тяжёлый день.</p>

      <p>И Бровь вроде бы молодец, но если
        всё провалится из-за отсутствия аудиозаписи разговора с Александром — выйдет
        плохо. И Бровь вроде бы не виновата, но на самом деле виновата, ясно же.</p>

      <p>Плохо.</p>

      <p>— Простите за диктофон, —
        серьёзно прошептала она Максиму (Аркадьевичу), — правда, простите. Я не знаю,
        насколько это на самом деле важно, но, может, и без него получится?</p>

      <p>Кажется, при такой громкости
        музыки Габриэль Евгеньевич не смог бы услышать её, даже если бы пытался. Бровь
        на его месте пыталась бы, но он же гордый.</p>

      <p>Как удобно скрываться от гордых
        людей!</p>

      <p>— Получится, — устало и так же
        тихо ответил Максим (Аркадьевич), — не переживайте из-за записи. Мы возили вашу
        пробирку в Порт, чтобы Дима быстро проанализировал содержимое и определил, что
        внутри. По результатам анализа выяснилось, что там продукты распада вируса.</p>

      <p>Видела Бровь этот анализ, ага.</p>

      <p>— Если бы у них всё прошло как
        задумано, от ваших действий заражение всё равно бы не началось. Настоящий вирус
        они собирались вылить в канализацию через подвал. Но, поскольку мы знали об
        этом заранее, в подвале была установлена специальная аппаратура. Редкая и
        дорогая, вы с такой незнакомы: записывает не звук, а изображение.</p>

      <p>Аппаратура, записывающая
        картинку? Такое бывает?</p>

      <p>Закрома Университета почти так же
        велики, как закрома Святотатыча.</p>

      <p>— Так вот, в подвалах всё прошло
        успешно. Люди действительно приходили, запись есть. Поскольку по закону доступ
        к канализационным люкам имеется только у сантехников, а они все на службе у
        Университета, доказать правонарушение просто. Доказать его авторство сложнее,
        но лица видны, а значит, есть, с чем работать.</p>

      <p>Шпионский роман превращается в
        шпионские изображения! Если бы Бровь была на месте людей, подбрасывающих вирус,
        она бы непременно встала в крутую позу. Кстати, кто знает — может, на выходе из
        Порта тоже записывают изображение. Тогда у них есть образец <i>действительно
          крутого</i> закуривания.</p>

      <p>Правда, остаётся вопрос.</p>

      <p>— Так что, дом Константина
        Константьевича всё-таки заразили?</p>

      <p>— Доказать преступление без
        состава преступления невозможно, — отрезал Максим (Аркадьевич). — Бедроградская
        гэбня слишком давно и слишком старательно портит нам жизнь, и каждый раз всё
        сводится к сомнительным методам. Это должно когда-то закончиться. Поймите, мы
        приняли все возможные меры предосторожности. Вот только обезопаситься
        —&nbsp;недостаточно, необходимо доказать, <i>на
          что</i> они готовы пойти, чтобы только лишить нас того, что нам причитается. Но
        не беспокойтесь, ни Константину Константьевичу, ни
        кому-либо из простых обитателей его дома ничего не грозит. У нас есть
        лекарство, и мы заранее подготовились к его применению. Всех заражённых вылечат
        уже завтра.</p>

      <p>Звучит опасно, но кто сказал, что
        это плохо? И потом, Максим (Аркадьевич) — человек, способный влепить тройку за
        недостаточное количество пунктов библиографии. Он, как и все люди, может делать
        ошибки (они включают ту тройку), но никогда не стал бы руководить опасной
        операцией, не перепроверив всё двадцать-тридцать тысяч раз. Если жителям дома
        ничто не угрожает и есть запись попытки заражения, то собрать доказательства неслучившегося (вернее, полуслучившегося)
        преступления несложно.</p>

      <p>Это оставляет в клинической
        картине только одно слабое звено.</p>

      <p>— А я… я же видела Гошку лично,
        держала в руках пробирку. Я свидетель. Мне не опасно ходить по улице?</p>

      <p>Максим (Аркадьевич) был серьёзным
        и сдержанным человеком, поэтому, когда он улыбался, становилось совсем
        спокойно.</p>

      <p>— И снова: не переживайте.
        Сегодня ночью мы отправим запрос на расследование, завтра вечером всё уже
        закончится. Сейчас вам действительно не стоит возвращаться к себе домой.
        Поживёте немного у меня, я всё равно, — Максим (Аркадьевич) смерил гордый
        профиль Габриэля Евгеньевича тоскливым взглядом, — не ночую на своей квартире.
        Соседи надёжные, вопросов задавать не станут, но присмотрят. Я предупредил.
        Если что —&nbsp;есть прямой телефон на кафедру. Безопаснее места не найти.</p>

      <p>Лучше бы предложили пожить в
        Порту! Бровь нацепила бы на глаз повязку, сделала себе татуировку на пол-лица,
        и кто бы её тогда искал, ха-ха. Может, ей для конспирации даже выдали бы ручную
        крысу и научили завязывать настоящий пиратский хвост.</p>

      <p>— На факультет будете ездить с
        нашим таксистом. И обратно тоже.</p>

      <p>Махнув пиратским хвостом, вольная
        жизнь стремительно ускользала. Эх, негде развернуться нынче широкой душе. Ходи
        по головам Бедроградской гэбни, вывози из их цепких лап смертельные вирусы
        —&nbsp;всё равно не повод пропускать пары.</p>

      <p>И никакой перспективы разок
        поучаствовать в игре на раздевание Габриэля Евгеньевича.</p>

      <p>— А тот человек, который с Димой,
        эээ, сидел — это сын Святотатыча, да? Он просто
        портовый? А то мне показалось, что он тоже в курсе дел.</p>

      <p>Максим (Аркадьевич) посмотрел на
        Бровь с разочарованием и укоризной. Покачал головой.</p>

      <p>Качает головой, а сам шушукается
        за спиной у своего, эээ, завкафа как первокурсник. А
        на парах подобное поведение порицает и карает, разумеется.</p>

      <p>— Во-первых, он не сын
        Святотатыча. Во-вторых, не вы ли мне на прошлом экзамене доказывали, что
        готовили свой билет по академическому изданию его ПСС, а не чужим шпаргалкам?
        Так вот, каждый том академического издания сопровождается фотопортретом.</p>

      <p>Бровь должна ещё помнить, что
        сдавала на последнем экзамене и кому что доказывала? В стрессовой ситуации все
        склонны преувеличивать.</p>

      <p>— Это был Сергей Корнеевич
        Гуанако, светило исторической науки и нашей кафедры. Дважды почётный идеолог
        Всероссийского Соседства, трижды его же почётный покойник. И, помимо
        библиографии, вам следует знать о Гуанако две вещи. Во-первых, он давно и
        принципиально не в курсе никаких дел, плавает себе на Курёхине и радуется
        трижды загробной жизни. Во-вторых, — Максим (Аркадьевич) веско заглянул Брови в
        глаза, — вы его не видели. Разве что на задней обложке томов академического
        издания, которое читали, и я продолжу в это верить.</p>

      <p>Честная сделка.</p>

      <p>Однако же ради всего
        происходящего из пучин вынырнуло мёртвое светило! Понятно, что вовсе и не ради,
        просто на берег сошло, но в шпионских романах совпадений не бывает. Даже если
        вся священная миссия светила состоит в том, чтобы надраться с Димой и раздеть
        Габриэля Евгеньевича, это всё равно придаёт происходящему грандиозный масштаб.</p>

      <p>Светила смотрят на них с небес и
        складываются в знаки.</p>

      <p>Жаль, что основное веселье уже
        скорее закончилось, дальше лишь расследования и бюрократия. Только и останется,
        что на экзаменах гордо молчать и таить знание о том, что светило вовсе и не
        мёртвое, вовсе оно и живое, с серьгой в ухе и (нужна же светилу настоящая
        особая примета!) татуировкой на всю лопатку. А на татуировке, между прочим,
        написано «Курёхин», Бровь зоркая, она видела. А Курёхин, между прочим, — это
        корабль с нашим и ненашим. То есть, гм, их и не их.</p>

      <p>Бровь внимательная, она
        запомнила.</p>

      <p>Зоркая, внимательная и, увы,
        отныне очень молчаливая, потому что всё закончилось.</p>

      <p>Впрочем, когда в шпионских
        романах кто-то думает, что веселье закончилось, оно обычно как раз начинается.</p>

      <p>— Всё будет хорошо, — пробормотал
        Максим (Аркадьевич), — у нас достаточно доказательств и всё в порядке с
        безопасностью. Знать бы только, как там сложилось в Столице.</p>

      <p>Ну Макси-и-им (Аркадьевич), ну
        кто же так делает! Ясно же, что когда в шпионском романе говорят, что всё
        хорошо, всё оказывается плохо, доказательств нет, в безопасности дыры, а
        наивный оптимист потом трагически погибает!</p>

      <p>Если верить законам жанра, то
        после подобного высказывания только у Столицы есть шанс всё сделать правильно и
        оказаться в порядке.</p>

      <p>Ой.</p>
  </>
}

export default chapter01
